<template>
  <div class="min-h-screen flex-1 mt-1 bg-gray-100 px-4 py-3 items-center">
    <div class="bg-white w-full rounded-lg shadow pb-2">
      <div id="noShow" class="h-20 py-3 flex items-center border-gray-200 p-6 mt-5">
        <div class="flex w-full">
           <button
            :class="$colors.primary"
            class="rounded-full flex justify-center items-center w-8 h-8 mr-3"
            @click="RouterBack()"
          >
            <i class="material-icons">chevron_left</i>
          </button>

          <div class="text-xl font-bold text-green-700">{{$t('payement_details')}}</div>
        </div>
      </div>

      <!-- Historique changement de statut (CEO) -->
      <div v-if="!['Seller','Partner'].includes(currentUser.type) && statusHistory.length" id="noShow" class="mx-3 mb-3 bg-white rounded-lg border border-gray-200 p-4">
        <h3 class="font-bold text-gray-700 mb-2 flex items-center"><i class="material-icons text-green-600 mr-1" style="font-size:18px;">history</i> Historique de statut</h3>
        <ul class="divide-y divide-gray-100">
          <li v-for="(h,i) in statusHistory" :key="i" class="py-2 flex items-center justify-between text-sm">
            <div class="flex flex-col">
              <span class="text-gray-700"><b>{{ h.user ? (h.user.fullName || h.user.email) : 'Système' }}</b></span>
              <span class="text-xs text-gray-400">{{ $moment(h.date).format('DD/MM/YY HH:mm') }}</span>
            </div>
            <span class="whitespace-no-wrap">
              <span class="px-2 py-0.5 rounded-full bg-gray-100 text-gray-600 text-xs capitalize">{{ h.oldObject }}</span>
              <i class="material-icons align-middle text-gray-400" style="font-size:14px;">arrow_forward</i>
              <span class="px-2 py-0.5 rounded-full text-xs capitalize" :class="h.newObject==='validé'?'bg-green-100 text-green-700':'bg-orange-100 text-orange-700'">{{ h.newObject }}</span>
            </span>
          </li>
        </ul>
      </div>

      <div class="p-10" id="detailP" style="border: 2px solid #686565 !important; border-radius: 10px; padding: 11px; margin: 12px;padding-top: 8px; ">
        <div id="noShow"  class="flex justify-between mb-4 no-display">
          <h2 class="text-2xl font-bold mb-6 pb-2 tracking-wider uppercase"></h2><div class="relative mr-4 inline-block"><div class="text-gray-800 cursor-pointer w-10 h-10 rounded-full bg-gray-300 hover:bg-gray-300 inline-flex items-center justify-center" @click="openPopup"><svg  xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icon-tabler-printer"><rect x="0" y="0" width="24" height="24" stroke="none"></rect><path d="M17 17h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2"></path><path d="M17 9v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4"></path><rect x="7" y="13" width="10" height="8" rx="2"></rect></svg></div><div x-show.transition="showTooltip" class="z-40 shadow-lg text-center w-32 block absolute right-0 top-0 p-2 mt-12 rounded-lg bg-gray-800 text-white text-xs" style="display: none;"> Print this invoice! </div></div>
        </div>
          <div class="invoice" style="display: flex;">
                <div class="invoice-title" style="color: #999; font-size: 1.875rem; line-height: 2.25rem; margin-bottom: 0; font-weight: 700; text-transform: uppercase;">Invoice <span>#{{formData.id}}</span></div>
                <div class="invoice-des" style="text-align: right; margin-left: auto;">
                  <img style="margin-left: auto; width: 10.5rem; height: auto; display: block; vertical-align: middle;" alt="cod" src="https://storeno.b-cdn.net/rmexpressglob-v1/12-2024/1733757434470.jpeg" class="align-middle border-none invoice-logo">                     
                </div>
            </div>
       
           <section id="pdf-content" class="relative">
            <loading :active.sync="loading" :is-full-page="fullPage"></loading>
              <div class="flex space-x-3">
                <div
                  class="flex justify-between w-full h-auto  rounded-lg"
                >
                  <div class="flex w-full">
                  
                    <div class="w-full space-y-2">
                      <!-- <div class="text-base mt-2 mb-2 font-semibold text-gray-700">
                        {{$t('payement_no')}} : <span>#{{formData.id}}</span>
                      </div> -->

                      <div class="text-sm text-gray-600" style="color: black; font-weight: 600;"  >
                        {{$t('seller')}} :
                        <span
                          v-if="formData.seller"
                          class="justify-center text-xs  p-1 pl-3 pr-2 w-auto font-semibold rounded-full text-gray-700"
                        >
                          {{ formData.seller.fullName||formData.seller.company }}
                        </span>
                      </div> 
                      <div class="text-sm text-gray-600 capitalize" style="color: black; font-weight: 600;">
                        {{$t('warehouses')}} :
                        <span v-if="formData.warehouses && formData.warehouses.length>0" class="justify-center text-xs  p-1 pl-3 pr-2 w-auto font-semibold rounded-full text-gray-700">
                          <span v-for="(war, j) in formData.country" :key="j">
                            {{$f.getCountryNameByCode(options,war)}} <span v-if="j!=formData.country.length-1">, </span>
                        </span>
                        </span>
                        <span v-else class="justify-center text-xs  p-1 pl-3 pr-2 w-auto font-semibold rounded-full text-gray-700">{{ formData.country?$f.getCountryNameByCode(options,formData.country[0]):'' }}</span>
                      </div>
                      <div class="text-sm text-gray-600" style="color: black; font-weight: 600;"  >
                        {{$t('payement_method')}} :

                        <span
                          class="justify-center text-xs  p-1 pl-3 pr-2 w-auto font-semibold rounded-full text-gray-700"
                        >
                          {{ formData.method }}
                        </span>
                      </div>
                      <div class="text-sm text-gray-600" style="color: black; font-weight: 600;"  >
                        {{$t('date_payement')}}:
                        <span
                          class="justify-center text-xs  p-1 pl-3 pr-2 w-auto font-semibold rounded-full text-gray-700"
                        >
                          {{  $moment(formData.date).format('yyyy-MM-DD') }} 
                        </span>
                      </div>
                      <div v-if="formData.intervalDate && formData.intervalDate.fromDate && formData.intervalDate.toDate" class="text-sm text-gray-600" style="color: black; font-weight: 600;"  >
                        {{$t('Periode')}}:
                        <span
                          class="justify-center text-xs  p-1 pl-3 pr-2 w-auto font-semibold rounded-full text-gray-700"
                        >
                          [{{ $moment(formData.intervalDate.fromDate).format('yyyy-MM-DD')}} - {{  $moment(formData.intervalDate.toDate).format('yyyy-MM-DD')}}]
                        </span>
                      </div>
                      <div class="text-sm text-gray-600" style="color: black; font-weight: 600;"  >
                        Number of orders:
                        <span
                          class="justify-center text-xs  p-1 pl-3 pr-2 w-auto font-semibold rounded-full text-gray-700"
                        >
                        {{ formData.count }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Retry CPA Payout — visible only for admin/CEO on validé payments with CPA orders -->
              <div v-if="!['Seller','Partner'].includes(currentUser.type) && formData.status === 'validé' && hasCpaOrders && !cpaAlreadyPaid" class="mt-3 mb-2 flex items-center">
                <button @click="retryCpaPayout" :disabled="retryingCpa" class="inline-flex items-center px-3 py-1.5 text-xs font-medium rounded-md text-white" style="background:#1ba79e;" :style="retryingCpa?'opacity:0.6;cursor:not-allowed':''">
                  <i class="material-icons mr-1" style="font-size:16px;">refresh</i>
                  {{ retryingCpa ? 'En cours...' : 'Retry CPA Payout' }}
                </button>
                <span v-if="cpaRetryMsg" class="ml-3 text-xs" :class="cpaRetryOk?'text-green-600':'text-red-600'">{{ cpaRetryMsg }}</span>
              </div>

              <!-- Orders -->
              <div class="w-full"><div class="login-or"><hr class="hr-or"><span style="left: 41%;" class="span-or">Orders</span></div></div>
              <section style="border: 2px dashed rgb(104, 101, 101) !important;border-radius: 10px;padding: 5px;margin-top: 10px;">
               
                  <table  v-for="(group, index) in dataGroupedByCountry"  :key="index" class="w-full leading-normal mt-4" style="page-break-after: avoid; page-break-before: avoid;width: 100%; overflow: scroll;line-height: 1.5;">
                    <caption style="background: #cdcdcd; font-weight: bold; font-size: 1.1em; margin-left: -1px;">{{  $f.getCountryNameByCode(options,group.country)||$f.getCountryNameByCode(options,formData.country[0])}} <small>({{group.count}} orders)</small></caption>
                    <thead>
                      <tr>
                        <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-left  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider"> # </th>
                        <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider"> {{$t('order_id')}} </th>
                        <!-- <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider"> {{$t('Country')}} </th> -->
                          <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider"> Product name </th>
                        <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider"> {{$t('total_price')}}</th>
                        <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">  {{$t('confirmation_fees')}}</th>
                        <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">  {{$t('Upsell fees')}}</th>
                        <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider" v-if="formData.details[0] && formData.details[0].fulfillement_fees_vat">  {{$t('fulfillement_fees')}}</th>
                        <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider" v-if="formData.country=='MA'">  {{$t('city')}}</th>
                        <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">  {{$t('shipping_fees')}}</th>
                        <th v-if="group.orders.find(mrk=> mrk.marketplaces && mrk.marketplaces.length>0)" style="
                          letter-spacing: 0.05em;

                          text-transform: capitalize;

                          text-align: left;

                          padding-left: 0.75rem;

                          padding-right: 0.75rem;

                          padding-top: 0.25rem;

                          padding-bottom: 0.25rem;

                          font-size: 0.75rem;

                          font-weight: 600;

                          border-bottom-width: 2px;

                          border-color: #edf2f7;

                          border-style: solid;
                        "
                        class="px-3 py-1 border-b-2 border-slate-200 text-xs font-semibold bg-primary text-white capitalize tracking-wider">
                        {{ $t("Marketplace product achat") }}
                      </th>
                        <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider" v-if="formData.details[0] && formData.details[0].stock_fee_vat">  {{$t('stock_fee')}}</th>
                        <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider" v-if="formData.details[0] && formData.details[0].commission_vat">  {{$t('commission_percentage')}}</th>
                        <!--  <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">  {{$t('refund_fees')}}</th>
                        <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider"> {{$t('cancellation_fees')}}</th>
                        <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider" v-if="formData.details[0] && formData.details[0].quality_control!=0"> {{$t('quality_control')}}</th>-->
                        <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">  {{$t('total')}}</th>
                      </tr>
                    </thead>
                    <tbody v-for="(item, index) in group.orders" :key="item._id">
                <tr 
                  style="background-color: #f7fafc;border-style: solid;border-color: #e2e8f0;display: table-row;vertical-align: inherit;"
                  :class="index % 2 == 0 ? 'bg-gray-100' : ''">
                  <td
                    :style="item.affiliate && item.affiliate.type || (item.POD && item.POD.name) || (item.cpa && item.cpa.supplier)?'background-color: #1ba79e;padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;':'padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;'"
                    class="px-3 py-1 text-left border-b border-gray-200   bg-white text-xs">
                    <p style="margin: 0;" class="text-gray-700  whitespace-no-wrap" :style="item.affiliate && item.affiliate.type || (item.POD && item.POD.name) || (item.cpa && item.cpa.supplier)?'color: black;':''">
                      <span class="font-semibold">{{ index + 1 }}</span>
                    </p>
                  </td>
                  <td
                    :style="item.affiliate && item.affiliate.type || (item.POD && item.POD.name) || (item.cpa && item.cpa.supplier)?'background-color: #1ba79e;padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;':'padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;'"
                    class="px-2 py-1 border-b border-gray-200   bg-white text-xs">
                    <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap" :style="item.affiliate && item.affiliate.type || (item.POD && item.POD.name) || (item.cpa && item.cpa.supplier)?'color: black;':''">
                      <span class="font-semibold">{{ item.order.id }}
                      </span>
                    </p>
                  </td>
                  <!-- <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;" 
                          class="px-2 py-1 border-b border-gray-200   bg-white text-xs"
                        >
                          <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                            <span class="font-semibold">{{  $f.getCountryNameByCode(options,item.country)||$f.getCountryNameByCode(options,formData.country[0])}}</span>
                          </p>
                        </td> -->
                  <td
                     :style="item.affiliate && item.affiliate.type || (item.POD && item.POD.name) || (item.cpa && item.cpa.supplier)?'background-color: #1ba79e;padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;':'padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;'"
                    class="px-2 py-1 border-b border-gray-200   bg-white text-xs">
                    <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap" :style="item.affiliate && item.affiliate.type || (item.POD && item.POD.name) || (item.cpa && item.cpa.supplier)?'color: black;':''">
                      <span class="font-semibold">{{ item.order.details && item.order.details[0] &&
                        item.order.details[0].name ? ProductNameSplit(item.order.details):item.products||'' }}</span>
                      <!-- <span class="font-semibold">{{ item.products||'' }}</span> -->
                    </p>
                  </td>
                  <td
                     :style="item.affiliate && item.affiliate.type || (item.POD && item.POD.name) || (item.cpa && item.cpa.supplier)?'background-color: #1ba79e;padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;':'padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;'"
                    class="px-2 py-1 border-b border-gray-200   bg-white text-xs">
                    <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap" :style="item.affiliate && item.affiliate.type || (item.POD && item.POD.name) || (item.cpa && item.cpa.supplier)?'color: black;':''">
                      <span class="font-semibold">{{ (item.shipping_refund_vat != 0 || item.shipping_cancel_vat != 0) ? 0 :item.order.totalPrice }}
                        <small style="padding-left:2px" v-if="item.affiliate && item.affiliate.type">(Order Affiliate)</small>
                        <small style="padding-left:2px" v-if="item.POD && item.POD.name">(Order POD)</small>
                        <small style="padding-left:2px" v-if="item.cpa && item.cpa.supplier">(Order CPA)</small>
                      </span>
                    </p>
                  </td>
                  <td :class="[item.affiliate && item.affiliate.type || (item.POD && item.POD.name) || (item.cpa && item.cpa.supplier)?'empty-row':'']"
                     :style="item.affiliate && item.affiliate.type || (item.POD && item.POD.name) || (item.cpa && item.cpa.supplier)?'background-color: #1ba79e;padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;':'padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;'"
                    class="px-2 py-1 border-b border-gray-200   bg-white text-xs">
                    <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                      <span class="font-semibold">{{ item.confirmation_vat }}
                      </span>
                    </p>
                  </td>
                  <td :class="[item.upsell_vat ? '' : 'empty-row',item.affiliate && item.affiliate.type || (item.POD && item.POD.name) || (item.cpa && item.cpa.supplier)?'empty-row':'']"
                     :style="item.affiliate && item.affiliate.type || (item.POD && item.POD.name) || (item.cpa && item.cpa.supplier)?'background-color: #1ba79e;padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;':'padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;'"
                    class="px-2 py-1 border-b border-gray-200   bg-white text-xs">
                    <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                      <span class="font-semibold">{{ item.upsell_vat || '' }}
                      </span>
                    </p>
                  </td>
                  <td :class="[item.affiliate && item.affiliate.type || (item.POD && item.POD.name) || (item.cpa && item.cpa.supplier)?'empty-row':'']"
                   :style="item.affiliate && item.affiliate.type || (item.POD && item.POD.name) || (item.cpa && item.cpa.supplier)?'background-color: #1ba79e;padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;':'padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;'"
                    v-if="formData.details[0] && formData.details[0].fulfillement_fees_vat != 0"
                    class="px-2 py-1 border-b border-gray-200   bg-white text-xs">
                    <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                      <span class="font-semibold">{{ item.fulfillement_fees_vat }}
                      </span>
                    </p>
                  </td>
                  <td
                     :style="item.affiliate && item.affiliate.type || (item.POD && item.POD.name) || (item.cpa && item.cpa.supplier)?'background-color: #1ba79e;padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;':'padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;'"
                    v-if="formData.country == 'MA'" class="px-2 py-1 border-b border-gray-200   bg-white text-xs">
                    <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                      <span class="font-semibold">{{ item.order.customer.city }}
                      </span>
                    </p>
                  </td>
                  <td :class="[item.affiliate && item.affiliate.type || (item.POD && item.POD.name) || (item.cpa && item.cpa.supplier)?'empty-row':'']"
                    :style="item.affiliate && item.affiliate.type || (item.POD && item.POD.name) || (item.cpa && item.cpa.supplier)?'background-color: #1ba79e;padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;':'padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;'"
                    class="px-2 py-1 border-b border-gray-200   bg-white text-xs">
                    <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                      <span class="font-semibold">{{ item.shipping_vat }}
                      </span>
                    </p>
                  </td>
                  <td
                    v-if="group.orders.find(mrk=> mrk.marketplaces && mrk.marketplaces.length>0)"
                  :class="[
                    (!item.marketplaces || (item.marketplaces && item.marketplaces.length === 0)) ? 'empty-row': '',
                  ]" :style="(item.affiliate && item.affiliate.type) ||
                    (item.POD && item.POD.name) ||
                    (item.cpa && item.cpa.supplier)
                    ? 'background-color: #1ba79e;padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;'
                    : 'padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;'
                    " class="px-2 py-1 border-b border-slate-200 bg-white text-xs">
                    <p style="margin: 0" class="text-slate-700 whitespace-no-wrap">
                      <span v-if="item.marketplaces && item.marketplaces.length>0"  class="font-semibold">{{ $f.checkMarketplace(item.marketplaces,'feesPayment') }}</span>
                    </p>
                  </td>
                  <td v-if="formData.details[0] && formData.details[0].stock_fee_vat"
                    :style="item.affiliate && item.affiliate.type || (item.POD && item.POD.name) || (item.cpa && item.cpa.supplier)?'background-color: #1ba79e;padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;':'padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;'"
                    class="px-2 py-1 border-b border-gray-200   bg-white text-xs">
                    <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                      <span class="font-semibold">{{ item.stock_fee_vat }}
                      </span>
                    </p>
                  </td>
                  <td v-if="formData.details[0] && formData.details[0].commission_vat"
                    :style="item.affiliate && item.affiliate.type || (item.POD && item.POD.name) || (item.cpa && item.cpa.supplier)?'background-color: #1ba79e;padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;':'padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;'"
                    class="px-2 py-1 border-b border-gray-200   bg-white text-xs">
                    <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                      <span class="font-semibold">{{ item.commission_vat }}
                      </span>
                    </p>
                  </td>

                  <!-- <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"  :class="item.shipping_refund_vat==0?'empty-row':''" class="px-2 py-1 border-b border-gray-200   bg-white text-xs"><p style="margin: 0;" class="text-gray-700 whitespace-no-wrap"><span class="font-semibold">{{ item.shipping_refund_vat==0?'':item.shipping_refund_vat }} </span></p></td>
                        <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"  :class="item.shipping_cancel_vat==0?'empty-row':''"  class="px-2 py-1 border-b border-gray-200   bg-white text-xs"><p style="margin: 0;" class="text-gray-700 whitespace-no-wrap"><span class="font-semibold">{{ item.shipping_cancel_vat==0?'':item.shipping_cancel_vat  }} </span></p></td>
                        <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"  v-if="formData.details[0] && formData.details[0].quality_control!=0" class="px-2 py-1 border-b border-gray-200   bg-white text-xs"><p style="margin: 0;" class="text-gray-700 whitespace-no-wrap"><span class="font-semibold">{{ item.quality_control==0?'':item.quality_control  }} </span></p></td>-->
                  <td
                     :style="item.affiliate && item.affiliate.type || (item.POD && item.POD.name) || (item.cpa && item.cpa.supplier)?'background-color: #1ba79e;padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;':'padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;'"
                    class="px-2 py-1 border-b border-gray-200   bg-white text-xs">
                    <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap" :style="item.affiliate && item.affiliate.type || (item.POD && item.POD.name) || (item.cpa && item.cpa.supplier)?'color: black;':''">
                      <span class="font-semibold">{{ item.amount }} <small style="padding-left:5px" v-if="item.affiliate && item.affiliate.type || (item.POD && item.POD.name)">(Commission)</small><small style="padding-left:5px" v-if="item.cpa && item.cpa.supplier">(Commission — {{ item.cpa.cpaSuppliers && item.cpa.cpaSuppliers.length > 1 ? 'Mixte' : (item.cpa.commissionMode === 'delivery' ? 'Livraison' : 'Confirmé') }})</small> </span>
                    </p>
                  </td>
                </tr>
              </tbody>
                    <tbody v-if="dataGroupedByCountry.length>1">
                      <tr>
                        <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"  class="text-right text-sm text-gray-600 no-border" colspan="6"><span contenteditable="">Sales</span></td>
                        <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"  class="text-right text-sm text-gray-700 no-border" colspan="2"><span>{{group.sales.toFixed(2)}}</span> <sup>{{group.currency}}</sup></td>
                      </tr>
                      <tr>
                        <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"  class="text-right text-sm text-gray-600 no-border" colspan="6"><span contenteditable="">Fees</span></td>
                        <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"  class="text-right text-sm text-gray-700 no-border" colspan="2"><span>{{group.fees.toFixed(2)}}</span> <sup>{{group.currency}}</sup></td>
                      </tr>
                      <tr>
                        <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"  class="text-right text-sm text-gray-600 no-border" colspan="6"><span contenteditable="">Amount</span></td>
                        <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"  class="text-right text-sm text-gray-700 no-border" colspan="2"><span>{{group.amount.toFixed(2)}}</span> <sup>{{group.currency}}</sup></td>
                      </tr>
                      <tr>
                        <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"  class="text-right text-sm text-gray-600 no-border" colspan="6"><span contenteditable=""><svg class="fill-current  float-right" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M5 18c4.667 4.667 12 1.833 12-4.042h-3l5-6 5 6h-3c-1.125 7.98-11.594 11.104-16 4.042zm14-11.984c-4.667-4.667-12-1.834-12 4.041h3l-5 6-5-6h3c1.125-7.979 11.594-11.104 16-4.041z"/></svg></span></td>
                        <td  style="font-weight: bold;font-size: 14px;padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"  class="text-right text-sm text-gray-700 no-border" colspan="2"><span>{{(group.amount/formData.infoCurrency.find(o => o.currencyName === group.currency).currency).toFixed(2)}}</span> <sup>MAD</sup></td>
                      </tr>
                    </tbody>
                  </table>
              </section>
         
              <div v-if="dataGroupedRefundsByCountry.length>0 || dataGroupedExpeditionsByCountry.length>0 || dataGroupedChargesByCountry.length>0" class="w-full"><div class="login-or"><hr class="hr-or"><span style="left: 42%;"  class="span-or">Credits</span></div></div>
              <section v-if="dataGroupedRefundsByCountry.length>0 || dataGroupedExpeditionsByCountry.length>0 || dataGroupedChargesByCountry.length>0" style="border: 2px dashed rgb(232 3 3) !important;border-radius: 10px;padding: 5px;margin-top: 10px;">
                  <!-- Remboursements -->
                  <section v-if="dataGroupedRefundsByCountry.length>0" style="border: 2px solid rgb(232 3 3) !important;border-radius: 10px;padding: 5px;margin-top: 10px;">
                      <!-- <div v-if="dataGroupedRefundsByCountry.length>0" class="w-full"><div class="login-or"><hr class="hr-or"><span style="left: 42%;"  class="span-or">Remboursements ({{formData.refunds.length}})</span></div></div> -->
                        
                        <table class="w-full leading-normal" style="page-break-after: avoid; page-break-before: avoid;width: 100%; overflow: scroll;line-height: 1.5;">
                          <caption style="background: rgb(226 118 118); font-weight: bold; font-size: 1.1em; margin-left: -1px;"> <small>({{formData.refunds.length}} Remboursements)</small></caption>
                          <thead>
                            <tr>
                                <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-left  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">#</th> 
                                <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-left  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">{{$t('warehouse')}}</th> 
                                <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">ORDER_ID</th> 
                                <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">{{$t('customer')}}</th>
                                <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">{{$t('date')}}</th>
                                <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">{{$t('traking_number')}}</th>
                                <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">{{$t('details')}}</th>
                                <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">{{$t('total_price')}}</th>
                                
                            </tr>
                          </thead>
                          <tbody v-for="(item, index) in formData.refunds" :key="item._id">
                            <tr  style="background-color: #f7fafc;border-style: solid;border-color: #e2e8f0;display: table-row;vertical-align: inherit;" :class="index % 2 == 0 ? 'bg-gray-100' : ''">
                              <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;" 
                                class="px-3 py-1 text-left border-b border-gray-200   bg-white text-xs"
                              >
                                <p style="margin: 0;" class="text-gray-700  whitespace-no-wrap">
                                  <span class="font-semibold">{{ index+1 }}</span>
                                </p>
                              </td>
                               <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;" 
                                class="px-3 py-1 text-left border-b border-gray-200   bg-white text-xs"
                              >
                                <p style="margin: 0;" class="text-gray-700  whitespace-no-wrap">
                                  <span class="font-semibold">{{   $f.getCountryNameByCode(options,item.country) }}</span>
                                </p>
                              </td>

                              <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;" 
                                class="px-2 py-1 border-b border-gray-200   bg-white text-xs"
                              >
                                <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                                  <span class="font-semibold"
                                    >{{ item.shipping.orderObjet.id }}
                                  </span>
                                </p>
                              </td>
                                <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;" 
                                class="px-2 py-1 border-b border-gray-200   bg-white text-xs"
                              >
                                  <div class="leading-5 text-blue-900 capitalize" v-if="item.shipping.orderObjet">{{item.shipping.orderObjet.customer.fullName}}</div><div v-if="item.shipping.orderObjet.customer" class="font-light text-gray-700 text-smm">{{item.shipping.orderObjet.customer.phone}}</div>
                              
                              </td>
                              <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;" 
                              class="px-2 py-1 border-b border-gray-200   bg-white text-xs"
                            >
                              <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                                <span class="font-semibold">{{$moment(item.shipping.date).format('yyyy-MM-DD')}}</span>
                              </p>
                            </td>
                              <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;" 
                                class="px-2 py-1 border-b border-gray-200   bg-white text-xs"
                              >
                                <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                                  <span class="font-semibold">{{ item.shipping.trackingNumber }}</span>
                                </p>
                              </td>
                              <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;" 
                                class="px-2 py-1 border-b border-gray-200   bg-white text-xs"
                              >
                                <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                                  <span class="font-semibold"
                                    >{{item.shipping.orderObjet.details.length}} Products
                                  </span>
                                </p>
                              </td>
                              <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"  
                                class="px-2 py-1 border-b border-gray-200   bg-white text-xs"
                              >
                                <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                                  <span class="font-semibold"
                                    >{{ item.fees_amount  }}  <sup>{{ item.currency }}</sup>
                                  </span>
                                  <span class="pl-1" v-if="item.marketplaces && item.marketplaces.length > 0">(Produit marketplace)</span>
                                </p>
                              </td>
                            
                            </tr>
                          </tbody>
                          
                          <tbody v-if="dataGroupedRefundsByCountry.length>1">
                          
                            <tr>
                              <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"  class="text-right text-sm text-gray-600 no-border" colspan="5"><span contenteditable="">Fees</span></td>
                              <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"  class="text-right text-sm text-gray-700 no-border" colspan="3">
                                  <!-- <span>{{group.fees.toFixed(2)}}</span> <sup>{{group.currency}}</sup> -->
                                  <span v-for="(price, j) in formData.amountRefundsCurrency" :key="j">
                                      {{price.fees_amount.toFixed(2)}} <sup>{{price.currency}}</sup> <span v-if="j!=formData.amountRefundsCurrency.length-1">|</span>
                                  </span>
                              </td>
                            </tr>
                            <tr>
                              <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"  class="text-right text-sm text-gray-600 no-border" colspan="5"><span contenteditable=""><svg class="fill-current  float-right" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M5 18c4.667 4.667 12 1.833 12-4.042h-3l5-6 5 6h-3c-1.125 7.98-11.594 11.104-16 4.042zm14-11.984c-4.667-4.667-12-1.834-12 4.041h3l-5 6-5-6h3c1.125-7.979 11.594-11.104 16-4.041z"/></svg></span></td>
                              <td  style="font-weight: bold;font-size: 14px;padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"  class="text-right text-sm text-gray-700 no-border" colspan="3">
                                  <!-- <span>{{(group.fees/formData.infoCurrency.find(o => o.currencyName === group.currency).currency).toFixed(2)}}</span> <sup>MAD</sup> -->
                                  {{ Math.round(formData.amountCurrency.map(item => item.fees_refoundMad).reduce((prev, next) => prev + next) )}}  <sup>MAD</sup>  
                              </td>
                            </tr>
                          </tbody>
                        </table>
                  </section>
                  <!-- Expedition -->
                  <section v-if="dataGroupedExpeditionsByCountry.length>0" style="border: 2px solid rgb(232 3 3) !important;border-radius: 10px;padding: 5px;margin-top: 10px;">
                      <!-- <div v-if="dataGroupedExpeditionsByCountry.length>0" class="w-full"><div class="login-or"><hr class="hr-or"><span style="left: 42%;"  class="span-or">Expeditions</span></div></div> -->
                        
                      <table class="w-full leading-normal" style="page-break-after: avoid; page-break-before: avoid;width: 100%; overflow: scroll;line-height: 1.5;">
                        <caption style="background: rgb(226 118 118); font-weight: bold; font-size: 1.1em; margin-left: -1px;"> <small>({{formData.expeditions.length}} Expeditions)</small></caption>
                        <thead>
                          <tr>
                              <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-left  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">#</th> 
                              <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-left  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">{{$t('warehouse')}}</th> 
                              <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">ID</th> 
                              <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">WEIGHT (KG) </th> 
                              <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">Number Of Packages</th> 
                              <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">RECEPTION DATE</th>  
                              <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">PRODUCTS</th>     
                              <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">FROM</th> 
                              <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">EXPEDITION FEES</th>      
                          </tr>
                        </thead>
                        <tbody v-for="(item, index) in formData.expeditions" :key="item._id">
                          <tr  style="background-color: #f7fafc;border-style: solid;border-color: #e2e8f0;display: table-row;vertical-align: inherit;" :class="index % 2 == 0 ? 'bg-gray-100' : ''">
                            <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;" 
                              class="px-3 py-1 text-left border-b border-gray-200   bg-white text-xs"
                            >
                              <p style="margin: 0;" class="text-gray-700  whitespace-no-wrap">
                                <span class="font-semibold">{{ index+1 }}</span>
                              </p>
                            </td>
                              <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;" 
                                class="px-3 py-1 text-left border-b border-gray-200   bg-white text-xs"
                              >
                                <p style="margin: 0;" class="text-gray-700  whitespace-no-wrap">
                                  <span class="font-semibold">{{   $f.getCountryNameByCode(options,item.country) }}</span>
                                </p>
                              </td>
                            <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;" 
                              class="px-2 py-1 border-b border-gray-200   bg-white text-xs"
                            >
                              <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                                <span class="font-semibold"
                                  >{{ item.id.id }}
                                </span>
                              </p>
                            </td>
                              <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;" 
                              class="px-2 py-1 border-b border-gray-200   bg-white text-xs"
                            >
                              <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                                <span class="font-semibold">{{ item.id.type && item.id.type === 'transfer'?'':item.id.weight || 0 }}</span>
                              </p>
                            </td>
                            <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;" 
                              class="px-2 py-1 border-b border-gray-200   bg-white text-xs"
                            >
                              <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                                <span class="font-semibold">{{ item.id.type && item.id.type === 'transfer'?item.id.numberOfPackages || 0 :'' }}</span>
                              </p>
                            </td>
                            <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;" 
                              class="px-2 py-1 border-b border-gray-200   bg-white text-xs"
                            >
                              <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                                <span class="font-semibold">{{$moment(item.id.arrivalDate).format('yyyy-MM-DD')}}</span>
                              </p>
                            </td>
                            <td  style="width: 30px; overflow: hidden; display: inline-block; white-space: nowrap;padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;" 
                              class="px-2 py-1 border-b border-gray-200   bg-white text-xs"
                            >
                              <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                                <span v-html="ProductGroupNmae(item.id, item.currency)" class="font-semibold"></span>
                              </p>
                            </td>
                            <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"  
                              class="px-2 py-1 border-b border-gray-200   bg-white text-xs"
                            >
                              <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                                <span class="font-semibold"
                                  >{{ $f.getCountryNameByCode(optionsCountries,item.id.country) }}
                                </span>
                              </p>
                            </td>
                            <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"    
                              class="px-2 py-1 border-b border-gray-200   bg-white text-xs"
                            >
                              <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                                <span class="font-semibold"
                                  >{{ item.fees_amount }} <sup>{{ item.currency }}</sup>
                                </span>
                              </p>
                            </td>
                          </tr>
                        </tbody>
                        
                        <tbody v-if="dataGroupedExpeditionsByCountry.length>1">
                        
                          <tr>
                            <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"  class="text-right text-sm text-gray-600 no-border" colspan="5"><span contenteditable="">Fees</span></td>
                            <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"  class="text-right text-sm text-gray-700 no-border" colspan="3">
                                <!-- <span>{{group.fees.toFixed(2)}}</span> <sup>{{group.currency}}</sup> -->
                                <span v-for="(price, j) in formData.amountExpeditionsCurrency" :key="j">
                                    {{price.fees_amount.toFixed(2)}} <sup>{{price.currency}}</sup> <span v-if="j!=formData.amountExpeditionsCurrency.length-1">|</span>
                                </span>
                            </td>
                          </tr>
                          <tr>
                            <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"  class="text-right text-sm text-gray-600 no-border" colspan="5"><span contenteditable=""><svg class="fill-current  float-right" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M5 18c4.667 4.667 12 1.833 12-4.042h-3l5-6 5 6h-3c-1.125 7.98-11.594 11.104-16 4.042zm14-11.984c-4.667-4.667-12-1.834-12 4.041h3l-5 6-5-6h3c1.125-7.979 11.594-11.104 16-4.041z"/></svg></span></td>
                            <td  style="font-weight: bold;font-size: 14px;padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"  class="text-right text-sm text-gray-700 no-border" colspan="3">
                               <!-- <span>{{(group.fees/(formData.infoCurrency.find(o => o.currencyName === group.currency).currencyCredit||formData.infoCurrency.find(o => o.currencyName === group.currency).currency)).toFixed(2)}}</span> <sup>MAD</sup> -->
                               {{ Math.round(formData.amountCurrency.map(item => item.fees_expeditionMad).reduce((prev, next) => prev + next) )}}  <sup>MAD</sup>  
                            </td>
                          </tr>
                        </tbody>
                      </table>
                </section>
                    <!-- Charges -->
                 <section v-if="dataGroupedChargesByCountry.length>0" style="border: 2px solid rgb(232 3 3) !important;border-radius: 10px;padding: 5px;margin-top: 10px;">
                    <!-- <div v-if="dataGroupedChargesByCountry.length>0" class="w-full"><div class="login-or"><hr class="hr-or"><span style="left: 43%;"  class="span-or">Charges</span></div></div> -->
                    
                    <table class="w-full leading-normal" style="page-break-after: avoid; page-break-before: avoid;width: 100%; overflow: scroll;line-height: 1.5;">
                      <caption style="background: rgb(226 118 118); font-weight: bold; font-size: 1.1em; margin-left: -1px;"><small>({{formData.charges.length}} Charges)</small></caption>
                      <thead>
                        <tr>
                            <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-left  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">#</th> 
                            <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-left  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">{{$t('warehouse')}}</th> 
                            <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">ID</th> 
                            <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" colspan="3" class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">COMMENT</th> 
                            <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">DATE</th> 
                            <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">AMOUNT</th>  
                        </tr>
                      </thead>
                      <tbody v-for="(item, index) in formData.charges" :key="item._id">
                        <tr  style="background-color: #f7fafc;border-style: solid;border-color: #e2e8f0;display: table-row;vertical-align: inherit;" :class="index % 2 == 0 ? 'bg-gray-100' : ''">
                          <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;" 
                            class="px-3 py-1 text-left border-b border-gray-200   bg-white text-xs"
                          >
                            <p style="margin: 0;" class="text-gray-700  whitespace-no-wrap">
                              <span class="font-semibold">{{ index+1 }}</span>
                            </p>
                          </td>
                          <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;" 
                                class="px-3 py-1 text-left border-b border-gray-200   bg-white text-xs"
                              >
                                <p style="margin: 0;" class="text-gray-700  whitespace-no-wrap">
                                  <span class="font-semibold">{{   $f.getCountryNameByCode(options,item.country) }}</span>
                                </p>
                              </td>
                          <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;" 
                            class="px-2 py-1 border-b border-gray-200   bg-white text-xs"
                          >
                            <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                              <span class="font-semibold"
                                >{{ item.id.id }}
                              </span>
                            </p>
                          </td>
                            <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"  colspan="3"
                            class="px-2 py-1 border-b border-gray-200   bg-white text-xs"
                          >
                            <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                              <span class="font-semibold">{{ item.id.comment }}</span>
                              <button v-if="['affiliate','marketplace','cpa'].includes(item.id.type)" @click="showOrder(item.id.type)" id="noShow"
                                class="ml-2">
                                <i class="material-icons animation-pulse align-middle">
                                  remove_red_eye</i>
                              </button>
                            </p>
                          </td>
                          <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;" 
                            class="px-2 py-1 border-b border-gray-200   bg-white text-xs"
                          >
                            <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                              <span class="font-semibold">{{$moment(item.id.date).format('yyyy-MM-DD')}}</span>
                            </p>
                          </td>
                          <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"    
                            class="px-2 py-1 border-b border-gray-200   bg-white text-xs"
                          >
                            <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                              <span class="font-semibold"
                                >{{ item.fees_amount }} <sup>{{ item.currency }}</sup>
                              </span>
                            </p>
                          </td>
                        </tr>
                      </tbody>
                      
                      <tbody v-if="dataGroupedChargesByCountry.length>1">
                      
                        <tr>
                          <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"  class="text-right text-sm text-gray-600 no-border" colspan="5"><span contenteditable="">Fees</span></td>
                          <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"  class="text-right text-sm text-gray-700 no-border" colspan="3">
                              <!-- <span>{{group.fees.toFixed(2)}}</span> <sup>{{group.currency}}</sup> -->
                              <span v-for="(price, j) in formData.amountChargesCurrency" :key="j">
                                {{price.fees_amount.toFixed(2)}} <sup>{{price.currency}}</sup> <span v-if="j!=formData.amountChargesCurrency.length-1">|</span>
                              </span>
                          </td>
                        </tr>
                        <tr>
                          <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"  class="text-right text-sm text-gray-600 no-border" colspan="5"><span contenteditable=""><svg class="fill-current  float-right" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M5 18c4.667 4.667 12 1.833 12-4.042h-3l5-6 5 6h-3c-1.125 7.98-11.594 11.104-16 4.042zm14-11.984c-4.667-4.667-12-1.834-12 4.041h3l-5 6-5-6h3c1.125-7.979 11.594-11.104 16-4.041z"/></svg></span></td>
                          <td  style="font-weight: bold;font-size: 14px;padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"  class="text-right text-sm text-gray-700 no-border" colspan="3">
                              <!-- <span>{{(group.fees/(formData.infoCurrency.find(o => o.currencyName === group.currency).currencyCredit||formData.infoCurrency.find(o => o.currencyName === group.currency).currency)).toFixed(2)}}</span> <sup>MAD</sup> -->
                              {{ Math.round(formData.amountCurrency.map(item => item.fees_chargeMad).reduce((prev, next) => prev + next) )}}  <sup>MAD</sup>  
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </section>
              </section>
            
                <div class="py-2 ml-auto mt-5 w-full sm:w-4/5" :style="dataGroupedByCountry.length>1?'border-top: 2px solid black;width: 80%;padding-top: 0.5rem;padding-bottom: 0.5rem;margin-left: auto;':'width: 80%;padding-top: 0.5rem;padding-bottom: 0.5rem;margin-left: auto;'">
                  <div class="flex justify-between mb-2" style="margin-bottom: 9px;justify-content: space-between;display: flex;">
                    <div class="text-gray-800 text-right flex-1" style="text-align: right;width: 50%;color: #2d3748;">Total Sales:</div>
                    <div class="text-right w-40" style="width: 50%;text-align: right;">
                      <div v-if="formData.amountCurrency && formData.infoCurrency  && formData.infoCurrency.length>0 && formData.amountCurrency.length>0" class="text-gray-800 font-medium">
                          <span v-for="(price, j) in formData.amountCurrency" :key="j">
                            {{price.totalPrice.toFixed(2)}} <sup>{{price.currency}}</sup> <span v-if="j!=formData.amountCurrency.length-1">|</span>
                          </span>
                      </div>
                      <div v-else class="text-gray-800 font-medium">{{ totalSales }} <sup v-if="idWharhouse">{{ idWharhouse.currency}}</sup></div>
                    </div>
                  </div>
                  <div class="flex justify-between mb-2" style="margin-bottom: 9px;justify-content: space-between;display: flex;">
                    <div class="text-gray-800 text-right flex-1" style="text-align: right;width: 50%;color: #2d3748;">Total Fees:</div>
                    <div class="text-right w-40" style="width: 50%;text-align: right;">
                      <div v-if="formData.amountCurrency && formData.infoCurrency && formData.infoCurrency.length>0  && formData.amountCurrency.length>0" class="text-gray-800 font-medium">
                          <span v-for="(price, j) in formData.amountCurrency" :key="j">
                            {{price.fees.toFixed(2)}} <sup>{{price.currency}}</sup> <span v-if="j!=formData.amountCurrency.length-1">|</span>
                          </span>
                      </div>
                      <div v-else class="text-gray-800 font-medium">{{ totalFees }} <sup v-if="idWharhouse">{{ idWharhouse.currency}}</sup></div>
                    </div>
                  </div>

                  <template v-if="formData.amountCurrency && formData.infoCurrency && formData.infoCurrency.length>0  && formData.amountCurrency.length>0 && (formData.amountRefundsCurrency.length!=0 || formData.amountExpeditionsCurrency.length!=0 || formData.amountChargesCurrency.length!=0)">
                     <div   class="flex justify-between mb-2 border-t" style="margin-bottom: 9px;justify-content: space-between;display: flex;">
                        <div class="text-gray-800 text-right flex-1" style="text-align: right;width: 50%;color: #2d3748;font-weight: 700;">Profit Net:</div>
                        <div class="text-right w-40" style="width: 50%;text-align: right;">
                          <div class="text-gray-800 font-medium"> 
                              <span v-for="(price, j) in formData.amountCurrency" :key="j">
                                {{(price.totalPrice - price.fees)}} <sup>{{price.currency}}</sup> <span v-if="j!=formData.amountCurrency.length-1">|</span>
                              </span>
                          </div>
                        </div>
                      </div>
                      <div class="flex justify-between">
                        <div class="text-xl text-gray-600 text-right flex-1"><svg class="fill-current  float-right" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M5 18c4.667 4.667 12 1.833 12-4.042h-3l5-6 5 6h-3c-1.125 7.98-11.594 11.104-16 4.042zm14-11.984c-4.667-4.667-12-1.834-12 4.041h3l-5 6-5-6h3c1.125-7.979 11.594-11.104 16-4.041z"/></svg></div>
                          <div class="text-right w-40" style="width: 50%;text-align: right;">
                              <div class="text-xl text-gray-800 font-bold">
                                   {{ Math.round(formData.amountCurrency.map(item => item.amountSales_FeesMad).reduce((prev, next) => prev + next) )}}  <sup>MAD</sup>  
                              </div>
                          </div>
                      </div>
                  </template>

                  <template v-if="formData.amountRefundsCurrency && formData.infoCurrency && formData.infoCurrency.length>0 && formData.amountRefundsCurrency.length>0">
                      <div  class="flex justify-between mb-2 border-t" style="margin-bottom: 9px;justify-content: space-between;display: flex;">
                        <div class="text-gray-800 text-right flex-1" style="text-align: right;width: 50%;color: #2d3748;">Remboursements Fees  <small>({{formData.refunds.length}} orders)</small>:</div>
                        <div class="text-right w-40" style="width: 50%;text-align: right;">
                          <div  class="text-gray-800 font-medium">
                              <span v-for="(price, j) in formData.amountRefundsCurrency" :key="j">
                                {{price.fees_amount.toFixed(2)}} <sup>{{price.currency}}</sup> <span v-if="j!=formData.amountRefundsCurrency.length-1">|</span>
                              </span>
                          </div>
                        </div>
                      </div>
                      <div class="flex justify-between">
                          <div class="text-xl text-gray-600 text-right flex-1"><svg class="fill-current  float-right" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M5 18c4.667 4.667 12 1.833 12-4.042h-3l5-6 5 6h-3c-1.125 7.98-11.594 11.104-16 4.042zm14-11.984c-4.667-4.667-12-1.834-12 4.041h3l-5 6-5-6h3c1.125-7.979 11.594-11.104 16-4.041z"/></svg></div>
                            <div class="text-right w-40" style="width: 50%;text-align: right;">
                                <div class="text-xl text-gray-800 font-bold">
                                    {{ Math.round(formData.amountCurrency.map(item => item.fees_refoundMad).reduce((prev, next) => prev + next) )}}  <sup>MAD</sup>  
                                </div>
                            </div>
                      </div>
                  </template>

                 <template v-if="formData.amountExpeditionsCurrency && formData.infoCurrency && formData.infoCurrency.length>0 && formData.amountExpeditionsCurrency.length>0">
                    <div class="flex justify-between mb-2 border-t" style="margin-bottom: 9px;justify-content: space-between;display: flex;">
                      <div class="text-gray-800 text-right flex-1" style="text-align: right;width: 50%;color: #2d3748;">Expeditions Fees  <small>({{formData.expeditions.length}} expeditions)</small>:</div>
                      <div class="text-right w-40" style="width: 50%;text-align: right;">
                        <div  class="text-gray-800 font-medium">
                            <span v-for="(price, j) in formData.amountExpeditionsCurrency" :key="j">
                              {{price.fees_amount.toFixed(2)}} <sup>{{price.currency}}</sup> <span v-if="j!=formData.amountExpeditionsCurrency.length-1">|</span>
                            </span>
                        </div>
                      </div>
                    </div>
                    <div class="flex justify-between">
                        <div class="text-xl text-gray-600 text-right flex-1"><svg class="fill-current  float-right" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M5 18c4.667 4.667 12 1.833 12-4.042h-3l5-6 5 6h-3c-1.125 7.98-11.594 11.104-16 4.042zm14-11.984c-4.667-4.667-12-1.834-12 4.041h3l-5 6-5-6h3c1.125-7.979 11.594-11.104 16-4.041z"/></svg></div>
                          <div class="text-right w-40" style="width: 50%;text-align: right;">
                              <div class="text-xl text-gray-800 font-bold">
                                  {{ Math.round(formData.amountCurrency.map(item => item.fees_expeditionMad).reduce((prev, next) => prev + next) )}}  <sup>MAD</sup>  
                              </div>
                        </div>
                    </div>
                 </template>

                  <template v-if="formData.amountChargesCurrency && formData.infoCurrency && formData.infoCurrency.length>0 && formData.amountChargesCurrency.length>0">
                    <div class="flex justify-between mb-2 border-t" style="margin-bottom: 9px;justify-content: space-between;display: flex;">
                        <div class="text-gray-800 text-right flex-1" style="text-align: right;width: 50%;color: #2d3748;">Charges Fees  <small>({{formData.charges.length}} charges)</small>:</div>
                        <div class="text-right w-40" style="width: 50%;text-align: right;">
                          <div  class="text-gray-800 font-medium">
                              <span v-for="(price, j) in formData.amountChargesCurrency" :key="j">
                                {{price.fees_amount.toFixed(2)}} <sup>{{price.currency}}</sup> <span v-if="j!=formData.amountChargesCurrency.length-1">|</span>
                              </span>
                          </div>
                        </div>
                    </div>
                    <div class="flex justify-between">
                        <div class="text-xl text-gray-600 text-right flex-1"><svg class="fill-current  float-right" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M5 18c4.667 4.667 12 1.833 12-4.042h-3l5-6 5 6h-3c-1.125 7.98-11.594 11.104-16 4.042zm14-11.984c-4.667-4.667-12-1.834-12 4.041h3l-5 6-5-6h3c1.125-7.979 11.594-11.104 16-4.041z"/></svg></div>
                          <div class="text-right w-40" style="width: 50%;text-align: right;">
                              <div class="text-xl text-gray-800 font-bold">
                                  {{ Math.round(formData.amountCurrency.map(item => item.fees_chargeMad).reduce((prev, next) => prev + next) )}}  <sup>MAD</sup>  
                              </div>
                        </div>
                    </div>
                  </template>
                  
                  
                  <div v-if="formData.vat" class="flex justify-between mb-4" style="margin-bottom: 0.80rem;justify-content: space-between;display: flex;">
                    <div class="text-sm text-gray-600 text-right flex-1" style="text-align: right;width: 50%;color: #2d3748;">TVA ({{formData.vat}}%)</div>
                    <div class="text-right w-40" style="width: 50%;text-align: right;">
                      <div class="text-sm text-gray-600" style="color: black; font-weight: 600;"  >{{formData.vatFees}} <sup v-if="idWharhouse">{{ idWharhouse.currency}}</sup></div>
                    </div>
                  </div>
                  <div v-if="formData.transfert_fees" class="flex justify-between mb-4" style="margin-bottom: 0.80rem;justify-content: space-between;display: flex;">
                    <div class="text-sm text-gray-600 text-right flex-1" style="text-align: right;width: 50%;color: #2d3748;">
                      Frais {{ getPaymentMethodLabel(formData.method) }}
                      <span v-if="formData.transferFeeDetails && formData.transferFeeDetails.feeValue">({{ formData.transferFeeDetails.feeValue }}{{ formData.transferFeeDetails.feeType === 'fixed' ? ' fixe' : '%' }})</span>
                    </div>
                    <div class="text-right w-40" style="width: 50%;text-align: right;">
                      <div class="text-sm text-gray-600" style="color: black; font-weight: 600;"  >-{{formData.transfert_fees.toFixed(2)}} <sup v-if="idWharhouse">{{ idWharhouse.currency}}</sup></div>
                    </div>
                  </div>
                
                  <div class="py-2 border-t border-b">
                    <div class="flex justify-between" style="justify-content: space-between;display: flex;">
                      <div class="text-gray-600 text-right flex-1" style="text-align: right;width: 50%;color: #2d3748;font-weight: 800;">Payment net:</div>
                      
                      <div v-if="formData.amountCurrency && formData.infoCurrency  && formData.infoCurrency.length>0  && formData.amountCurrency.length>0" class="text-right w-40" style="width: 50%;text-align: right;">
                          <span v-for="(price, j) in formData.amountCurrency" :key="j">
                            {{(price.amount - (j === 0 && formData.transfert_fees ? formData.transfert_fees : 0)).toFixed(2)}} <sup>{{price.currency}}</sup> <span v-if="j!=formData.amountCurrency.length-1">|</span>
                          </span>
                      </div>
                      <div v-else class="text-right w-40" style="width: 50%;text-align: right;">{{ total.toFixed(2) }} <sup v-if="idWharhouse">{{ idWharhouse.currency}}</sup></div>
                    </div>
                    <div class="flex justify-between">
                      <div class="text-xl text-gray-600 text-right flex-1"><svg class="fill-current  float-right" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M5 18c4.667 4.667 12 1.833 12-4.042h-3l5-6 5 6h-3c-1.125 7.98-11.594 11.104-16 4.042zm14-11.984c-4.667-4.667-12-1.834-12 4.041h3l-5 6-5-6h3c1.125-7.979 11.594-11.104 16-4.041z"/></svg></div>
                        <div v-if="formData.amountCurrency && formData.infoCurrency && formData.infoCurrency.length>0  && formData.amountCurrency.length>0" class="text-right w-40" style="width: 50%;text-align: right;">
                            <div class="text-xl text-gray-800 font-bold">

                              <!-- {{formData.amountCurrency.map(item => {
                                  const objC = formData.infoCurrency.find(o => o.currencyName === item.currency); 
                                  return item.amount/objC.currency;
                              }).reduce((prev, curr) => prev + curr, 0).toFixed(2)}}  -->
                              
                            {{ netWalletAmount }}  <sup>{{ netWalletCurrency }}</sup>

                            </div>
                        </div>
                        <div v-else class="text-right w-40" style="width: 50%;text-align: right;">
                            <div class="text-xl text-gray-800 font-bold" v-if="formData.info">{{ (total/formData.info.currency).toFixed(2)}} <sup>MAD</sup></div>
                        </div>
                      
                    </div>
                  </div>
              </div>
                  
                 
          
             

               <!--Modal New courier Shipping -->
             <vue-modal-2 class="no-display"  name="nameInvoice" :headerOptions="{title: 'Payement Info'}" :noFooter="true" modalSize="lg" @on-close="close">
                <div class="bg-white rounded-lg">
                    <div class="rounded-lg flex">
                    <div class="w-1/4 flex justify-center items-center">
                        <span class="w-16 h-16 bg-blue-600 text-white p-3 rounded-full"><i class="material-icons" style="font-size: 40px;">file_download</i></span>
                    </div>
                    <div class="w-full pr-4 mt-4">
                      <div class="grid grid-cols-1">
                           <div class="border hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                    <p>
                                        <label for="fullname" class="bg-white text-gray-700 px-1">Invoice Name <span :class="$colors.required">*</span></label>
                                    </p>
                                </div> 
                                <p>
                                    <input type="text"  v-model="InvoiceName" class="py-2 text-xs px-2 outline-none block h-full w-full"> 
                                </p>
                            </div> 
                      </div>
          
                    </div>
                    </div>
                    <div class="p-4 flex space-x-4">
                        <a href="#" @click="close" class="w-1/2 px-4 py-3 text-center bg-gray-500 text-white hover:bg-gray-400  font-bold rounded-lg text-sm">Cancel</a>
                        <a href="#" @click="generateReport" class="w-1/2 px-4 py-3 text-center text-blue-100 bg-blue-600 rounded-lg hover:bg-blue-700 hover:text-white font-bold text-sm">Confirme</a>
                    </div>
                </div>
            </vue-modal-2>     
            <!-- end  New courier  shipping -->

            <vue-modal-2 class="no-display" name="affiliate"
            :headerOptions="{ title: `Affiliate Orders (${dataAFF.length})` }" :noFooter="true" modalSize="xl"
            @on-close="$vm2.close('affiliate')">
            <div class="flex flex-col w-full h-auto p-5 pt-0 bottom_bitt">
              <div
                class="align-middle inline-block min-w-full overflow-hidden bg-white shadow-dashboard rounded-bl-lg rounded-br-lg"
                style="margin-bottom: 62px">
                <table class="min-w-full">
                  <thead>
                    <tr>
                      <th
                        class="px-3 py-1 siz12 bg-slate-200 border-b-2 border-t-2 border-slate-300 text-left leading-4 text-primary tracking-wider">
                        #
                      </th>
                      <th
                        class="px-3 py-1 siz12 bg-slate-200 border-b-2 border-t-2 border-slate-300 text-left text-sm leading-4 text-primary tracking-wider">
                        {{ $t("OFFRE NAME") }}
                      </th>

                      <th
                        class="px-3 py-1 siz12 bg-slate-200 border-b-2 border-t-2 border-slate-300 text-left text-sm leading-4 text-primary tracking-wider">
                        {{ $t("WAREHOUSE") }}
                      </th>

                      <th
                        class="px-3 py-1 siz12 bg-slate-200 border-b-2 border-t-2 border-slate-300 text-left text-sm leading-4 text-primary tracking-wider">
                        {{ $t("PRIX DE BASE") }}
                      </th>

                      <th
                        class="px-3 py-1 siz12 bg-slate-200 border-b-2 border-t-2 border-slate-300 text-left text-sm leading-4 text-primary tracking-wider">
                        {{ $t("QUANTITY") }}
                      </th>

                      <th
                        class="px-3 py-1 siz12 bg-slate-200 border-b-2 border-t-2 border-slate-300 text-left text-sm leading-4 text-primary tracking-wider">
                        {{ $t("Delivery Fee") }}
                      </th>

                      <th
                        class="px-3 py-1 siz12 bg-slate-200 border-b-2 border-t-2 border-slate-300 text-right text-sm leading-4 text-primary tracking-wider">
                        {{ $t("PROFITE") }}
                      </th>
                    </tr>
                  </thead>
                  <loading :active.sync="loadingAFF" :is-full-page="fullPage"></loading>
                  <tbody class="bg-white">
                    <tr v-for="(order, ind) in dataAFF" :key="ind">
                      <td class="border-t-2 border-slate-300 px-3 py-1">
                        <div class="flex items-center">
                          <div>
                            <div class="text-sm leading-5 text-slate-800">
                              {{ ind + 1 }}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td class="border-t-2 border-slate-300 px-3 py-1">
                        <div class="text-sm leading-5 siz12 text-blue-900">
                          <div class="flex-grow-1">
                            <h5 class="font-bold">
                              {{ order.product.name || "" }}
                            </h5>
                          </div>
                        </div>
                      </td>

                      <td class="px-3 py-1 text-left border-t-2 border-slate-300 whitespace-no-wrap">
                        <div class="text-sm leading-5 text-blue-900">
                          <span class="font-semibold">{{
                            $f.getCountryNameByCode(options, order.country)
                          }}</span>
                        </div>
                      </td>

                      <td class="px-3 py-1 text-left border-t-2 border-slate-300 whitespace-no-wrap">
                        <div class="text-sm leading-5 text-blue-900">
                          {{ order.totalPrice }}
                          <sup v-if="idWharhouse">{{
                            idWharhouse.currency
                          }}</sup>
                        </div>
                      </td>

                      <td class="border-t-2 border-slate-300 px-3 py-1">
                        <div class="text-sm leading-5 text-blue-900">
                          {{ order.quantity }}
                        </div>
                      </td>

                      <td class="border-t-2 border-slate-300 px-3 py-1">
                        <div class="text-sm leading-5 text-blue-900">
                          {{ order.shipping_vat }}
                          <sup v-if="idWharhouse">{{
                            idWharhouse.currency
                          }}</sup>
                        </div>
                      </td>

                      <td class="px-3 py-1 text-right border-t-2 border-slate-300 whitespace-no-wrap">
                        <div class="font-bold leading-5 text-blue-900">
                          {{
                            `${currencySettings === "MAD"
                              ? order.amountMAD
                              : order.amount
                            }`
                          }}
                          <sup>{{
                            `${currencySettings === "MAD" ? "MAD" : "$"}`
                          }}</sup>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="modal-footer px-5 border0-t text-right">
              <button @click="$vm2.close('affiliate')"
                class="flex text-white mx-auto max-w-sm rounded text-center bg-slate-500 py-2 px-8 items-center focus:outline-none md:float-right">
                Cancel
              </button>
            </div>
          </vue-modal-2>

            <vue-modal-2 class="no-display" name="marketplace"
            :headerOptions="{ title: `Marketplace quantity delivered (${dataMARKET.reduce((sum, item) => sum + item.quantity, 0)})` }" :noFooter="true" modalSize="xl"
            @on-close="$vm2.close('marketplace')">
            <div class="flex flex-col w-full h-auto p-5 pt-0 bottom_bitt">
              <div
                class="align-middle inline-block min-w-full overflow-hidden bg-white shadow-dashboard rounded-bl-lg rounded-br-lg"
                style="margin-bottom: 62px">
                <table class="min-w-full">
                  <thead>
                    <tr>
                      <th
                        class="px-3 py-1 siz12 bg-slate-200 border-b-2 border-t-2 border-slate-300 text-left leading-4 text-primary tracking-wider">
                        #
                      </th>
                      <th
                        class="px-3 py-1 siz12 bg-slate-200 border-b-2 border-t-2 border-slate-300 text-left text-sm leading-4 text-primary tracking-wider">
                        {{ $t("PRODUCT MARKET NAME") }}
                      </th>

                      <th
                        class="px-3 py-1 siz12 bg-slate-200 border-b-2 border-t-2 border-slate-300 text-left text-sm leading-4 text-primary tracking-wider">
                        {{ $t("WAREHOUSE") }}
                      </th>

                      <th
                        class="px-3 py-1 siz12 bg-slate-200 border-b-2 border-t-2 border-slate-300 text-left text-sm leading-4 text-primary tracking-wider">
                        {{ $t("PRIX DE VENTE") }}
                      </th>

                      <th
                        class="px-3 py-1 siz12 bg-slate-200 border-b-2 border-t-2 border-slate-300 text-left text-sm leading-4 text-primary tracking-wider">
                        {{ $t("QUANTITY") }}
                      </th>

                      <th
                        class="px-3 py-1 siz12 bg-slate-200 border-b-2 border-t-2 border-slate-300 text-left text-sm leading-4 text-primary tracking-wider">
                        {{ $t("SERVICE FEES") }} (10%)
                      </th>

                      <th
                        class="px-3 py-1 siz12 bg-slate-200 border-b-2 border-t-2 border-slate-300 text-right text-sm leading-4 text-primary tracking-wider">
                        {{ $t("PROFITE") }}
                      </th>
                    </tr>
                  </thead>
                  <loading :active.sync="loadingAFF" :is-full-page="fullPage"></loading>
                  <tbody class="bg-white">
                    <tr v-for="(order, ind) in dataMARKET" :key="ind">
                      <td class="border-t-2 border-slate-300 px-3 py-1">
                        <div class="flex items-center">
                          <div>
                            <div class="text-sm leading-5 text-slate-800">
                              {{ ind + 1 }}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td class="border-t-2 border-slate-300 px-3 py-1">
                        <div class="text-sm leading-5 siz12 text-blue-900">
                          <div class="flex-grow-1">
                            <h5 class="font-bold">
                              {{ order.product.name || "" }}
                            </h5>
                          </div>
                        </div>
                      </td>

                      <td class="px-3 py-1 text-left border-t-2 border-slate-300 whitespace-no-wrap">
                        <div class="text-sm leading-5 text-blue-900">
                          <span class="font-semibold">{{
                            $f.getCountryNameByCode(options, order.country)
                          }}</span>
                        </div>
                      </td>

                      <td class="px-3 py-1 text-left border-t-2 border-slate-300 whitespace-no-wrap">
                        <div class="text-sm leading-5 text-blue-900">
                          {{ order.price }}
                          <sup>{{order.currency}}</sup>
                        </div>
                      </td>

                      <td class="border-t-2 border-slate-300 px-3 py-1">
                        <div class="text-sm leading-5 text-blue-900">
                          {{ order.quantity }}
                        </div>
                      </td>

                      <td class="border-t-2 border-slate-300 px-3 py-1">
                        <div class="text-sm leading-5 text-blue-900">
                          {{ (order.price * order.quantity) - $f.getPriceMarket({price:order.price,quantity:order.quantity,serviceFees:10}) }} 
                          <sup>{{order.currency}}</sup>
                        </div>
                      </td>

                      <td class="px-3 py-1 text-right border-t-2 border-slate-300 whitespace-no-wrap">
                        <div class="font-bold leading-5 text-blue-900">
                          {{$f.getPriceMarket({price:order.price,quantity:order.quantity,serviceFees:10}) }} 
                          <sup>{{order.currency}}</sup>
                          <!-- {{
                            `${currencySettings === "MAD"
                              ? order.amountMAD
                              : order.amount
                            }`
                          }}
                          <sup>{{
                            `${currencySettings === "MAD" ? "MAD" : "$"}`
                          }}</sup> -->
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="modal-footer px-5 border0-t text-right">
              <button @click="$vm2.close('marketplace')"
                class="flex text-white mx-auto max-w-sm rounded text-center bg-slate-500 py-2 px-8 items-center focus:outline-none md:float-right">
                Cancel
              </button>
            </div>
          </vue-modal-2>


           

           </section>   
        </div>
    </div>

  </div>
</template>




<script>
import jsPDFInvoiceTemplate, { OutputType, jsPDF } from "jspdf-invoice-template";
import image from "@/assets/CODINAFRICA.png";
//import jsPDF from 'jspdf'

//or directly in browser
export default {
  props: {
     currentUser: { type: Object},
     idWharhouse: { type: Object},
     idPayment: { type: String},
   },
  data() {
    return {
      formData: {
        details: [],
      },
      expeditionCount:0,
      InvoiceName:"",
      image:image,
      fullPage: false,
      loading:false,
      content: [],
      headers: [{title:this.$t('order_id')},{title:this.$t('country')},{title:this.$t('products')},{title:this.$t('total_price')},{title:this.$t('confirmation')},{title:this.$t('shipping')},{title:this.$t('fulfillement')},{title:this.$t('total')}],
      total:0,
      totalFees:0,
      totalSales:0,
      options: this.$countries,
      currency:"",
     // currentUser: {},
      invoiceData:{},
      dataGroupedByCountry:[],
      dataGroupedExpeditionsByCountry:[],
      dataGroupedRefundsByCountry:[],
      dataGroupedChargesByCountry:[],
      dataProducts:[],
      optionsCountries: this.$countries,
      idP:this.idPayment,
      loadingAFF: false,
      dataAFF: [],
      dataMARKET: [],
      statusHistory: [],
      settingsList: [],
      retryingCpa: false,
      cpaRetryMsg: '',
      cpaRetryOk: false,
      cpaAlreadyPaid: false,
    };
  },
  computed: {
    hasCpaOrders() {
      return (this.formData.details || []).some(d => d.cpa && d.cpa.supplier);
    },
    // Devise dyal payment = li tGENERA biha (stored defaultCurrency) — MACHI payment method الحالي dyal seller
    netWalletCurrency() {
      return this.formData.defaultCurrency === 'USD' ? 'USD' : 'MAD';
    },
    // Payment net f'devise dyal wallet — nafs conversion dyal creditWalletFromPayment.
    // USD: kaypréféri l-taux CONFIGURÉ (snapshot dyal payment => sinon settings الحاليين). Taux=1 = machi configuré.
    netWalletAmount() {
      const ac = this.formData.amountCurrency, ic = this.formData.infoCurrency;
      if (!ac || !ic || !ac.length) return 0;
      const cur = this.netWalletCurrency;
      const sett = (this.settingsList && this.settingsList.length) ? this.settingsList : (this.$store.state.settings || []);
      // kayrejjaع premier taux "configuré" (>0 o machi 1). l'USD taux=1 = machi configuré.
      const pick = (...vals) => { for (const v of vals) { const n = parseFloat(v); if (n && n > 0 && n !== 1) return n; } return null; };
      const transfertFees = parseFloat(this.formData.transfert_fees) || 0;
      let sum = 0;
      ac.forEach((item, j) => {
        const info = ic.find(o => o.currencyName === item.currency) || ic.find(o => o.country === item.country) || {};
        const setInfo = ((sett.find(s => s.country === item.country) || {}).info) || {};
        let rate;
        if (cur === 'USD') {
          rate = pick(info.currencyUSDCredit, info.currencyUSD, setInfo.currencyUSDCredit, setInfo.currencyUSD)
               || info.currencyCredit || info.currency || setInfo.currencyCredit || setInfo.currency || 1;
        } else {
          rate = info.currencyCredit || info.currency || setInfo.currencyCredit || setInfo.currency || 1;
        }
        // Soustraire transfert_fees de la 1ère devise (bhal creditWalletFromPayment f backend)
        let local = (item.amount || 0);
        if (j === 0 && transfertFees) local -= transfertFees;
        sum += local / rate;
      });
      return cur === 'USD' ? (Math.floor(sum * 100) / 100).toFixed(2) : Math.floor(sum);
    },
  },
  watch: {
    'idPayment': async function () {
       console.log('idPayment------',this.idPayment)
       this.idP=this.idPayment;
       await this.dataToEdit();
    },
  },
  async mounted() {
    console.log('idWharhouse------------- 22',this.idWharhouse)
    console.log('idPayment------------- 22',this.idP)
    //await this.getCurrency();
   // await this.getUser();
   await this.dataToEdit();
    
  },
  methods: {
    async checkCpaAlreadyPaid() {
      try {
        const res = await this.$server.search("balancesHistories", { payment: this.formData._id, operationType: 'in' });
        if (res && res.content && res.content.results) {
          const sellerId = this.formData.seller && (this.formData.seller._id || this.formData.seller);
          const hasCpaCredit = res.content.results.some(bh => {
            const bhSeller = bh.seller && (bh.seller._id || bh.seller);
            return bhSeller && bhSeller.toString() !== (sellerId && sellerId.toString());
          });
          if (hasCpaCredit) this.cpaAlreadyPaid = true;
        }
      } catch (e) { /* noop */ }
    },
    async retryCpaPayout() {
      if (this.retryingCpa) return;
      this.retryingCpa = true;
      this.cpaRetryMsg = '';
      try {
        const res = await this.$server.update("payments", { _id: this.formData._id, retryCpa: true });
        if (res && res.content) {
          if (res.content.cpaPayoutWarning) {
            this.cpaRetryOk = false;
            this.cpaRetryMsg = res.content.cpaPayoutWarning;
          } else {
            this.cpaRetryOk = true;
            this.cpaAlreadyPaid = true;
            this.cpaRetryMsg = 'CPA payout crédité avec succès!';
          }
        } else {
          this.cpaRetryOk = false;
          this.cpaRetryMsg = (res && res.message) || 'Erreur lors du retry CPA';
        }
      } catch (e) {
        this.cpaRetryOk = false;
        this.cpaRetryMsg = e.message || 'Erreur réseau';
      }
      this.retryingCpa = false;
    },
    // Settings الحاليين (taux currency/USD per pays) — fallback l'conversion USD dyal payments قداام
    async loadSettingsRates() {
      try {
        const res = await this.$server.get("settings");
        this.settingsList = (res && res.content && res.content.details) ? res.content.details : [];
      } catch (e) { this.settingsList = []; }
    },
    // Historique dyal changement status dyal payment (mn userHistories)
    async getStatusHistory(paymentId) {
      try {
        if (!paymentId) return;
        const res = await this.$server.search("userHistories", { 'model.id': paymentId, 'model.name': 'payments', limit: 50 });
        const rows = (res && res.content && res.content.results) ? res.content.results : [];
        // ghir les entrées dyal changement status
        this.statusHistory = rows.filter(h => h.model && h.model.action && /change status/i.test(h.model.action));
      } catch (e) { this.statusHistory = []; }
    },
    getPaymentMethodLabel(method) {
      const labels = {
        cash: 'Cash',
        transfer: 'Virement',
        paypal: 'PayPal',
        orange_money: 'Orange Money',
        mtn_money: 'MTN Money',
        wave: 'Wave',
        inwi_money: 'Inwi Money',
        apple_pay: 'Apple Pay',
        wise: 'Wise',
        payoneer: 'Payoneer',
      };
      return labels[method] || method || 'Transfer';
    },
    async showOrder(nameAction) {
      this.$vm2.open(nameAction)

      // Appelle la fonction sur les deux datasets
      this.loadingAFF = true;
      await this.resolveProducts.call(this, this.dataAFF);
      await this.resolveProducts.call(this, this.dataMARKET);
      this.loadingAFF = false;
    },
    async resolveProducts(orders) {
      console.log('dataProducts-------',this.dataProducts)
      for (const order of orders) {
        if (order.product && !order.product.name) {
          const productId = order.product.toString();

          let product = this.dataProducts.find((p) => p.id.toString() === productId);

          if (!product) {
            const res = await this.$server.get("products", { id: productId });
            product = {
              id: productId,
              name: res.content.name,
            };
            this.dataProducts.push(product);
          }

          order.product = { name: product.name };
        }
      }
    },
    ProductGroupNmae(data,currency){
      let product="";
      let typeExp='Prix de 1 kilo: ';
      if(data.type && data.type === 'transfer') typeExp='Prix de 1 colis: ';
      for (let i in data.details) {
        if(data.details[i].name) product+=data.details[i].name+` (<span style="text-decoration: underline overline limegreen double 1.2px;">${typeExp+data.details[i].price_one_kiloOrPackage} <sup>${currency}</sup>)</span>`;
        if(data.details.length-1 != i) product+=" | "; 
      }
      return product;
    },
      getElementInArray(data,value){
        var result  = data.filter(function(o){
            let whar=o.warehouse;
            if(o.warehouse._id) whar=o.warehouse._id;
            return whar == value.toString();
        } );
        return result? result[0] : null; // or undefined
    },
    sumObjAmountCurrency(objArr,infoCurrency=[],refunds=[],expeditions=[],charges=[]) {
        var newArr = [];
        infoCurrency.forEach(row2 => { 
            var index = objArr.findIndex(x => x.currency == row2.currencyName); 
            if(index === -1) objArr.push({
              "count": 0,
              "currency": row2.currencyName,
              "country": row2.country,
              "totalPrice": 0,
              "amount": 0,
              "fees": 0
            })
        });

        expeditions.forEach(row => { row.type='expedition'; });
        charges.forEach(row => { row.type='charge'; });

        if(refunds.length>0) objArr = objArr.concat(refunds);
        if(expeditions.length>0) objArr = objArr.concat(expeditions);
        if(charges.length>0) objArr = objArr.concat(charges);

        //amount by mad
        objArr.forEach(row => { 
              row.amountSales_Fees=0;
              row.amountSales_FeesMad=0;
              row.amountMad=0;
              row.fees_amountMad=0;

              row.fees_refoundMad=0;
              row.fees_expeditionMad=0;
              row.fees_chargeMad=0;

              if(!row.amount) row.amount=0;
              if(!row.fees) row.fees=0;
              if(!row.totalPrice) row.totalPrice=0;
              if(!row.fees_amount) row.fees_amount=0;

              const getCurrency = infoCurrency.find(o => o.currencyName === row.currency);
                if(getCurrency && row.type && ['expedition','charge'].indexOf(row.type) !== -1){
                     row.amountMad = row.amount/getCurrency.currencyCredit;
                     row.fees_amountMad = row.fees_amount/getCurrency.currencyCredit;
                     if(row.type === "expedition") row.fees_expeditionMad = row.fees_amount/getCurrency.currencyCredit;
                     if(row.type === "charge") row.fees_chargeMad = row.fees_amount/getCurrency.currencyCredit;
                }else {
                   row.amountMad = row.amount/getCurrency.currency;
                   row.fees_amountMad = row.fees_amount/getCurrency.currency;
                   row.amountSales_FeesMad = (row.totalPrice-row.fees)/getCurrency.currency;
                   row.fees_refoundMad = row.fees_amount/getCurrency.currency;
                }
               
        });

        console.log('newArr------------11',objArr)

      let result = objArr.reduce((acc, curr) => {
        console.log('acc------------11',acc)
            let item = acc.find(item => item.currency === curr.currency);

            if (item) {
             
              if(!item.amountSales_Fees) item.amountSales_Fees=0; if(!curr.amountSales_Fees) curr.amountSales_Fees=0;
              if(!item.amount) item.amount=0; if(!curr.amount) curr.amount=0;
              if(!item.count) item.count=0; if(!curr.count) curr.count=0;
              if(!item.fees) item.fees=0; if(!curr.fees) curr.fees=0;
              if(!item.totalPrice) item.totalPrice=0; if(!curr.totalPrice) curr.totalPrice=0;
              if(!item.fees_amount) item.fees_amount=0; if(!curr.fees_amount) curr.fees_amount=0;

              if(!item.amountMad) item.amountMad=0; if(!curr.amountMad) curr.amountMad=0;
              if(!item.fees_amountMad) item.fees_amountMad=0; if(!curr.fees_amountMad) curr.fees_amountMad=0;
              if(!item.amountSales_FeesMad) item.amountSales_FeesMad=0; if(!curr.amountSales_FeesMad) curr.amountSales_FeesMad=0;

              if(!item.fees_refoundMad) item.fees_refoundMad=0; if(!curr.fees_refoundMad) curr.fees_refoundMad=0;
              if(!item.fees_expeditionMad) item.fees_expeditionMad=0; if(!curr.fees_expeditionMad) curr.fees_expeditionMad=0;
              if(!item.fees_chargeMad) item.fees_chargeMad=0; if(!curr.fees_chargeMad) curr.fees_chargeMad=0;

                item.amount += curr.amount;
                item.amountMad += curr.amountMad;
                item.count += curr.count;
                
                item.fees += curr.fees;
                item.totalPrice += curr.totalPrice;
                item.amountSales_Fees = item.totalPrice - item.fees;
                item.amountSales_Fees += curr.amountSales_Fees;
                item.amount -= curr.fees_amount;
                item.amountMad -= curr.fees_amountMad;

               
                item.fees_refoundMad += curr.fees_refoundMad;
                item.fees_expeditionMad += curr.fees_expeditionMad;
                item.fees_chargeMad += curr.fees_chargeMad;
                item.amountSales_FeesMad += curr.amountSales_FeesMad;
                
            } else {
              if(!curr.amountSales_Fees) curr.amountSales_Fees=0;
              if(!curr.fees_expeditionMad) curr.fees_expeditionMad=0;
              if(!curr.fees_refoundMad) curr.fees_refoundMad=0;
              if(!curr.fees_chargeMad) curr.fees_chargeMad=0;
              if(!curr.amount) curr.amount=0;
              if(!curr.count) curr.count=0;
              if(!curr.fees) curr.fees=0;
              if(!curr.totalPrice) curr.totalPrice=0;
              if(!curr.fees_amount) curr.fees_amount=0;
              if(!curr.amountMad) curr.amountMad=0;
              acc.push(curr);
            }

            return acc;
      }, []);
      console.log('newArr------------ 22',result)
      return result;

      // const datas = {};
      // objArr.forEach((prd,idx) => {
      //       if (datas[prd.currency]) {
      //           if(datas[prd.currency].amount) prd.amount += datas[prd.currency].amount;
      //           if(datas[prd.currency].count) prd.count += datas[prd.currency].count;
      //           if(datas[prd.currency].fees) prd.fees += datas[prd.currency].fees;
      //           if(datas[prd.currency].totalPrice) prd.totalPrice += datas[prd.currency].totalPrice;

      //           datas[prd.currency].amount =  prd.amount||0;
      //           datas[prd.currency].count =  prd.count||0;
      //           datas[prd.currency].fees =  prd.fees||0;
      //           datas[prd.currency].totalPrice =  prd.totalPrice||0;

      //           if(datas[prd.currency].fees_amount) prd.amount = prd.amount - datas[prd.currency].fees_amount;

      //           newArr[datas[prd.currency].index] = prd; 

      //       }else{

      //           datas[prd.currency] = {index:idx,amount:prd.amount||0,totalPrice:prd.totalPrice||0,fees:prd.fees||0,fees_amount:prd.fees_amount||0};
      //           if(!prd.amount) prd.amount=0;
      //           if(!prd.totalPrice) prd.totalPrice=0;
      //           if(!prd.fees) prd.fees=0;
      //           if(prd.fees_amount) prd.amount = prd.amount - prd.fees_amount;
      //           newArr.push(prd)
      //       }
      //   });
      //   console.log('newArr------------',newArr)
      //   return newArr;

    },
    RouterBack: function() {
       this.$router.back();
    },
   async sumProduct(data){
      console.log('data---------',data)
      let product="";
      for (let i in data) {
         const editData = await this.$server.get("products", {id:data[i].product,});
        product+=editData.content.name
        console.log('product---------',product)
        if(data.length-1 != i) product+=" ,"; 
      }
      return product;
    },
    async getCurrency(){
      await this.$store.dispatch('wharhouse/getCurrency').then((res) => {
              this.currency=res;
          })
         // this.currency='XOF';
    },
    close(){
         this.$vm2.close('nameInvoice');
    },
    openPopup(){
       this.$vm2.open('nameInvoice');
    },
    async generateReport() {
      if(!this.InvoiceName){
            alert("File name required", "warning");
            return false;
      }

           var mywindow = window.open('', 'PRINT', 'height=400,width=600');
            mywindow.document.write(`<html lang="en"><head><meta charset="utf-8"><title>${this.InvoiceName}</title>`);
            mywindow.document.write('<style type="text/css">.login-or { position: relative; color: rgb(0 0 0 / 55%); margin-top: 10px; margin-bottom: 10px; padding-top: 10px; padding-bottom: 10px; } .hr-or { height: 2px; margin-top: 0px !important; margin-bottom: 0px !important; border: 0; border-top: 2px solid rgb(0 0 0 / 55%); } .span-or { display: block; position: absolute; left: 47%; top: -2px; margin-left: -25px; background-color: #fff; width: 190px; text-align: center; font-weight: 700; }.text-xs { font-size: 0.75rem; }.font-semibold { font-weight: 600; }.text-center { text-align: center; } .pl-3 { padding-left: 0.75rem; }.pr-2 { padding-right: 0.5rem; } .p-1 { padding: 0.25rem; }#detailP{font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";}.no-display{display: none !important;}.no-border{border: none;}.text-xs{font-size: 0.75rem;}.text-gray-600{color: #718096;}td {display: table-cell;vertical-align: inherit;}.text-green-700{color: #01a653;}.invoice { display: flex; } .invoice-title { color: #999; font-size: 1.875rem; line-height: 2.25rem; margin-bottom: 0; font-weight: 700; text-transform: uppercase; } .invoice-des { text-align: right; margin-left: auto; } .invoice-logo{ margin-left: auto; width: 10.5rem; height: auto; display: block; vertical-align: middle; } caption { background: #cdcdcd; font-weight: bold; font-size: 1.1em; margin-left: -1px; /* Fix FF 1px issue */ } .w-40{ width: 25em; }.mb-6 { margin-bottom: 0.7rem; }.items-center{ align-items: center;} .align-items-center{ align-items: center !important; } .text-blue { color: #3182ce; } .row { display: flex; flex-wrap: wrap; } .text-sm-end { text-align: right; } .col-sm-5 { flex: 0 0 auto; width: 41.66666667%; } .text-sm-start { text-align: left; } .mb-sm-0 { margin-bottom: 0; } .mb-0 { margin-bottom: 0; } .mb-3 { margin-bottom: 1rem; } .imgg { vertical-align: inherit; width: 40px; display: inline-block; } .v-super{ vertical-align:super } .col-sm-7 { flex: 0 0 auto; width: 58.33333333%; } .h4 { font-size: 1.5rem; color: #0c2f54; } .p { line-height: 1.9; margin-top: 0; margin-bottom: 1rem; } .text-2xl { font-size: 1.5rem; } .pl-4 { padding-left: 1rem; } .border-l-2 { border-left-width: 2px !important;; border-color: #3182ce !important; } .mt-10{ margin-top: 10px; } .text-xss { font-size: 0.70rem !important; } .border-blue-600 { border-color: #3182ce; } .p-4 { padding: 1rem; } .mt-4 { margin-top: 1rem; } .tracking-wider { letter-spacing: 0.05em; } .text-gray-600 { color: #718096; } .text-left { text-align: left; } .text-blue-700 { color: #114f8f; } .px-6 { padding-left: 1.5rem; padding-right: 1.5rem; } .p-bb{ padding-bottom: 4px; } .py-3 { padding-top: 0.55rem; padding-bottom: 0.55rem; } .leading-4 { line-height: 1rem; } .border-b-2 { border-bottom-width: 2px; border-color: #e2e8f0 !important; } .border-t-2 { border-top-width: 2px; border-color: #e2e8f0 !important; } .border-gray-300 { border-color: #e2e8f0; } .bg-gray-200 { background-color: #edf2f7; } .h-auto { height: auto; } .bg-gray-100 { background-color: #f7fafc; } .border-dashed { border-style: dashed; } .border-gray-800 { border-color: #2d3748; } .text-xs { font-size: 0.55rem; } .font-semibold { font-weight: 600; } .dis-none{ display: none; } .text-gray-700 { color: #262728; } .rounded-full { border-radius: 9999px; } .border-b { border-bottom-width: 1px; border-color: #e2e8f0 !important; } .border-gray-200 { border-color: #8e9193; } tbody { display: table-row-group; vertical-align: middle; border-color: inherit; } tr { display: table-row; vertical-align: inherit; border-color: inherit; } .px-5 { padding-left: 1.10rem; padding-right: 1.10rem; } .width-40{ width: 50% !important; } .mb-3 { margin-bottom: 0.75rem; } sup { top: -0.5em; } .mt-10{ margin-bottom: 10px; } .border-b { border-bottom-width: 1px; border-color: #e2e8f0 !important; } .border-t { border-top-width: 1px; border-color: #e2e8f0 !important; } .text-xl { font-size: 1.25rem; } sub, sup { font-size: 75%; line-height: 0; position: relative; vertical-align: baseline; } .pt-4 { padding-top: 1rem; } .text-m { font-size: 18px; } .w-40 { width: 10rem; } .text-right { text-align: right; } .text-gray-900 { color: #1a202c; } .flex-1 { flex: 1 1 0%; } .py-2 { padding-top: 0.5rem; padding-bottom: 0.5rem; } .ml-auto { margin-left: auto; } .min-w-full { min-width: 100%; } .mt-5 { margin-top: 1.25rem; } table { display: table; border-collapse: collapse; box-sizing: border-box; text-indent: initial; border-spacing: 2px; border-color: grey; } .p-2 { padding: 0.5rem; } .ml-1 { margin-left: 0.25rem; } .overflow-visible{white-space: initial;}.trakingn img{width: 50%;}.mb-0{margin-bottom: 0px;}.w-1/4{width: 25%;}.w-3/4{width: 75%;}.m-0{margin:0}.pt-0{padding-top: 0px;}.mt-0{margin-top: 0px;}.py-1{padding-top: 0.25rem;padding-bottom: 0.25rem;}.px-3{padding-left: 0.75rem;padding-right: 0.75rem;}.w-2/4{width: 50%;}.mt-1{margin-top: 0.25rem;}.align-top{vertical-align: top;}p{margin:0}table{border-collapse: collapse;}table th, table td {border:1px solid #000;}.text-right{text-align:right}.flex-1{flex:1 1 0%}.w-40{width:10rem}.font-medium{font-weight:500}.py-1{padding-top:.25rem;padding-bottom:.25rem}.inline-block{display:inline-block}.mb-3{margin-bottom:.75rem}.py-2{padding-top:.5rem;padding-bottom:.5rem}.ml-auto{margin-left:auto}.border-black{border: 1px solid black;}.border{border-width:1px}.whitespace-no-wrap{white-space:nowrap}.text-center{text-align:center}.w-1/4{width: 25%}.text-left{text-align:left}.px-2{padding-left:.5rem;padding-right:.5rem}.min-w-full{min-width:100%}.mb-5{margin-bottom:1.25rem}.px-1{padding-left:.25rem;padding-right:.25rem}.mx-auto{margin-left:auto;margin-right:auto}body{font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";font-size:1em}.justify-between{justify-content:space-between}.w-full{width:100%}.block{display:block}.flex{display:flex}.uppercase{text-transform: uppercase;}.mb-2{margin-bottom: 0.5rem;}.mb-3{margin-bottom: 0.75rem;}.font-bold{font-weight: 700;}.font-semibold{font-weight:600}.text-xl{font-size: 1.25rem;line-height: 1.75rem;}.size-m{font-size: 12px;font-weight: 500;}@media print {@page {size:  auto; margin: 0mm;}}</style>');
            mywindow.document.write('</head><body style="margin:5mm;margin-top:5mm;page-break-after: avoid; page-break-before: avoid;">');
            mywindow.document.write(document.getElementById("detailP").innerHTML);
            mywindow.document.write('</body></html>');
            mywindow.document.close(); // necessary for IE >= 10
            mywindow.focus(); // necessary for IE >= 10*/
            const self=this;
            setTimeout(function () {
                mywindow.print();
                mywindow.close();
                self.$vm2.close('nameInvoice');
            }, 500);
            return false;

      //const outputTypes = jsPDFInvoiceTemplate.OutputType;
      let data=[];
      this.loading=true;
      for (const el of this.formData.details) {
         let obj = [el.order.id,this.$f.getCountryNameByCode(this.options,el.country),el.products,el.order.totalPrice,el.confirmation_vat,el.shipping_vat,el.fulfillement_fees_vat,el.amount];
        //  if(this.formData.details[0].confirmation_vat!=0) obj.push(el.confirmation_vat);
        //  if(this.formData.details[0].fulfillement_fees_vat!=0) obj.push(el.fulfillement_fees_vat);
        //  obj.push(el.order.customer.city);
        //  obj.push(el.shipping_vat);
         //if(this.formData.details[0].quality_control!=0) obj.push(el.quality_control);
         //obj.push(el.amount);
         data.push(obj);
      }
     console.log('data-------',data)
     console.log('dheider------',this.headers)
     var props = {
          outputType: OutputType.Save,
          returnJsPDFDocObject: true,
          fileName: this.InvoiceName,
          orientationLandscape: false,
          compress: true,
          logo: {
              src: this.image,
              type: 'PNG', //optional, when src= data:uri (nodejs case)
              width: 53.33, //aspect ratio = width/height
              height: 20,
              margin: {
                  top: 0, //negative or positive num, from the current position
                  left: 0 //negative or positive num, from the current position
              }
          },
          business: {
                name: "Invoice #: "+this.formData.id,
                address: "Seller: "+this.formData.seller.fullName,
                phone: "Payment Date: "+this.$moment(this.formData.date).format("yyyy-MM-DD"),
                email: "Warehouses: "+this.invoiceData.warehouses?this.invoiceData.warehouses:this.$f.getCountryNameByCode(this.options,this.formData.country),
                email_1: "Payement method: "+this.formData.method,
                website: "Number of orders: "+this.formData.count,
          },
          contact: {
              // label: "Invoice issued for:",
              // name: "Client Name",
              // address: "Albania, Tirane, Astir",
              // phone: "(+355) 069 22 22 222",
              // email: "client@website.al",
              // otherInfo: "www.website.al",
          },
          invoice: {
            // label: "Invoice #: ",
              num: 19,
              //invDate: "Payment Date: 01/01/2021 18:12",
            // invGenDate: "Invoice Date: 02/02/2021 10:17",
              headerBorder: false,
              header: this.headers,
              table:data,
              additionalRows: [{
                  col1: 'Total sales:',
                  col2: this.invoiceData.sales?this.invoiceData.sales:this.totalSales.toFixed().toString(),
                  col3: !this.invoiceData.sales?this.idWharhouse?this.idWharhouse.currency:'':'',
                  style: {
                      fontSize: 6 //optional, default 12
                  }
              },
              {
                    col1: 'Total fees:',
                    col2: this.invoiceData.fees?this.invoiceData.fees:this.totalFees.toFixed().toString(),
                    col3: !this.invoiceData.fees?this.idWharhouse?this.idWharhouse.currency:'':'',
                  style: {
                      fontSize: 6 //optional, default 12
                  }
              },
            {
              col1: "Net payment:",
              col2: this.invoiceData.mad?this.invoiceData.mad+' MAD':(this.total/this.formData.info.currency).toFixed(2).toString()+' MAD',
              //col3: this.invoiceData.mad?this.invoiceData.mad+' MAD':(this.total/this.formData.info.currency).toFixed(2).toString()+' MAD',
              style: {
                  fontSize: 8 //optional, default 12
              }
          },],
              // invDescLabel: "Invoice Note",
              // invDesc: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary.",
          },
          footer: {
            text: "Thank you very much for doing business with us.",
          },
          pageEnable: true,
          pageLabel: "Page ",
   };
      // var props = {
      // outputType: OutputType.Save,
      // returnJsPDFDocObject: true,
      // fileName: this.InvoiceName,
      // orientationLandscape: false,
      // logo: {
      //     src: this.image,
      //     width: 53.33, //aspect ratio = width/height
      //     height: 20,
      //     margin: {
      //         top: 0, //negative or positive num, from the current position
      //         left: 0 //negative or positive num, from the current position
      //     }
      // },
      // business: {
      //     name: "Invoice #: "+this.formData.id,
      //     address: "Seller: "+this.formData.seller.fullName,
      //     phone: "Payment Date: "+this.$moment(this.formData.date).format("yyyy-MM-DD"),
      //     email: "Warehouses: "+this.invoiceData.warehouses?this.invoiceData.warehouses:this.$f.getCountryNameByCode(this.options,this.formData.country),
      //     email_1: "Payement method: "+this.formData.method,
      //     website: "Number of orders: "+this.formData.count,
      // },
      // // contact: {
      // //     label: "Invoice issued for:",
      // //     name: "Client Name",
      // //     address: "Albania, Tirane, Astir",
      // //     phone: "(+355) 069 22 22 222",
      // //     email: "client@website.al",
      // //     otherInfo: "www.website.al",
      // // },
      // invoice: {
      //     //label: "Invoice #: ",
      //     num: 19,
      //     // invDate: "Payment Date: 01/01/2021 18:12",
      //     // invGenDate: "Invoice Date: 02/02/2021 10:17",
      //     headerBorder: false,
      //     tableBodyBorder: false,
      //     header: this.headers,
      //     table:data,
      //    // invTotalLabel: 'Total sales:',
      //     //invTotal: this.invoiceData.sales?this.invoiceData.sales:this.totalSales.toFixed().toString(),
      //     //invCurrency: !this.invoiceData.sales?this.currency:'',
      //     additionalRows: [{
      //       col1: 'Total sales:',
      //       col2: this.invoiceData.sales?this.invoiceData.sales:this.totalSales.toFixed().toString(),
      //       col3: !this.invoiceData.sales?this.currency:'',
      //       style: {
      //           fontSize: 10 //optional, default 12
      //       }
      //   },
      //   {
      //         col1: 'Total fees:',
      //         col2: this.invoiceData.fees?this.invoiceData.fees:this.totalFees.toFixed().toString(),
      //         col3: !this.invoiceData.fees?this.currency:'',
      //       style: {
      //           fontSize: 10 //optional, default 12
      //       }
      //   },
      //   {
      //       col1: 'SubTotal:',
      //       col2: '116,199.90',
      //       col3: 'ALL',
      //       style: {
      //           fontSize: 10 //optional, default 12
      //       }
      //   }],
      //     // row1: {
      //     //     col1: 'Total fees:',
      //     //     col2: this.invoiceData.fees?this.invoiceData.fees:this.totalFees.toFixed().toString(),
      //     //     col3: !this.invoiceData.fees?this.currency:'',
      //     //     style: {
      //     //         fontSize: 10 //optional, default 12
      //     //     }
      //     // },
      //     // row2: {
      //     //     col1: "Net payment:",
      //     //     col2: this.invoiceData.mad?this.invoiceData.mad+' MAD':(this.total.toFixed().toString()+' '+this.currency+' | '+(this.total/this.formData.info.currency).toFixed(2).toString()+' MAD'),
      //     //  //   col3: '' ,
      //     //     style: {
      //     //         fontSize: 10 //optional, default 12
      //     //     }
      //     // },
      //     // row3: {
      //     //     col1: "Net payment:",
      //     //     col2: '344455',
      //     //     col3:  'MAD',
      //     //     style: {
      //     //         fontSize: 10 //optional, default 12
      //     //     }
      //     // },
      //    // invDescLabel: "Net in MAD :",
      //     //invDesc: (this.total/this.formData.info.currency).toFixed(2).toString(),
      // },
      // footer: {
      //     text: "Thank you very much for doing business with us.",
      // },
      // pageEnable: true,
      // pageLabel: "Page ",
      //  };

  jsPDFInvoiceTemplate(props); 
   this.loading=false;
   this.$vm2.close('nameInvoice');
      // const printContents = document.getElementById('pdf-content').innerHTML;
      //  var mywindow = window.open('', 'PRINT', 'height=400,width=600');
      //   mywindow.document.write('<html lang="en"><head><meta charset="utf-8"><title>DELIVRY NOTE</title>');
      //   mywindow.document.write('<style type="text/css">.justify-center{justify-content: center;}.barcode-img svg{height:60px}p{margin:0}table{border-collapse: collapse;}table th, table td {border:1px solid #000;}.text-right{text-align:right}.flex-1{flex:1 1 0%}.w-40{width:10rem}.font-medium{font-weight:500}.py-1{padding-top:.25rem;padding-bottom:.25rem}.inline-block{display:inline-block}.mb-3{margin-bottom:.75rem}.py-2{padding-top:.5rem;padding-bottom:.5rem}.ml-auto{margin-left:auto}.border-black{border: 1px solid black;}.border{border-width:1px}.whitespace-no-wrap{white-space:nowrap}.text-center{text-align:center}.w-1/4{width: 25%}.text-left{text-align:left}.px-2{padding-left:.5rem;padding-right:.5rem}.min-w-full{min-width:100%}.mb-5{margin-bottom:1.25rem}.px-1{padding-left:.25rem;padding-right:.25rem}.mx-auto{margin-left:auto;margin-right:auto}body{font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";font-size:1em}.justify-between{justify-content:space-between}.w-full{width:100%}.block{display:block}.flex{display:flex}.uppercase{text-transform: uppercase;}.mb-2{margin-bottom: 0.5rem;}.mb-3{margin-bottom: 0.75rem;}.font-bold{font-weight: 700;}.font-semibold{font-weight:600}.text-xl{font-size: 1.25rem;line-height: 1.75rem;}.size-m{font-size: 12px;font-weight: 500;}@media print {@page {size:  auto; margin: 0mm;}}</style>');
      //   mywindow.document.write('</head><body style="margin:2mm">');
      //   mywindow.document.write(printContents);
      //   mywindow.document.write('</body></html>');
      //   mywindow.document.close(); // necessary for IE >= 10
      //   mywindow.focus(); // necessary for IE >= 10*/
      //   setTimeout(function () {
      //       mywindow.print();
      //       mywindow.close();
      //   }, 500);
      //   return false;
    },        
    async getUser() {
      const res = await this.$me;
      this.currentUser = res.content;
    },
    async getTotal(data) {
     this.total=0;
     this.totalFees=0;
     this.totalSales=0;
     console.log('data------------',data)
     if(data && data.length){
        data.forEach(item => {
               this.total += item.amount;
               this.totalFees+=(item.confirmation_vat+item.fulfillement_fees_vat+item.shipping_vat + this.$f.checkMarketplace(item.marketplaces||[],'feesPayment'));
               this.totalSales += item.order.totalPrice;
       });
     }
    },
    ProductNameSplit(data){
      let product="";
      console.log('ProductNameSplit-------------')
      for (let i in data) {
        if(data[i].name) product+=data[i].name
        if(data.length-1 != i) product+=" |"; 
      }
      return product;
    },
    async dataToEdit() {
      if (this.$route.params.id || this.idP) {
          this.loading=true;
         if(this.idP) this.$store.dispatch("actionloadingemail",{loadingEmail:'envoi'});
          this.dataProducts=[];
          console.log('this.$route.params.id-------------',this.$route.params.id||this.idP)
          const data = await this.$server.get("payments", {id: this.$route.params.id||this.idP,}); 
          
          if(data && data.content){
            let finalExcuse=false;
              this.formData = data.content;
              if(!['Seller','Partner'].includes(this.currentUser.type)) {
                this.getStatusHistory(this.formData._id);
                this.checkCpaAlreadyPaid();
              }
              this.loadSettingsRates();
              console.log(' this.formData 111', this.formData.details)
              this.formData.details=this.formData.details.sort((a,b) => (a.country > b.country) ? 1 : ((b.country > a.country) ? -1 : 0))
              for(const pd of this.formData.details){
                if(pd.cpa && pd.cpa.supplier && (!pd.cpa.cpaSuppliers || pd.cpa.cpaSuppliers.length === 0)){
                  const orderDets = (pd.order && pd.order.details || []).filter(det => det.cpa && det.cpa.supplier);
                  if(orderDets.length > 1){
                    const byKey = {};
                    for(const det of orderDets){
                      const sid = (det.cpa.supplier._id || det.cpa.supplier).toString();
                      const mode = det.cpa.commissionMode || 'confirmed';
                      const key = sid + '_' + mode;
                      const qty = parseInt(det.quantity) || 1;
                      if(!byKey[key]) byKey[key] = { purchasePrice: 0, commission: 0, commissionMode: mode, supplier: det.cpa.supplier, partner: det.cpa.partner, mlCommissionRate: parseFloat(det.cpa.mlCommissionRate) || 0 };
                      byKey[key].purchasePrice += (parseFloat(det.cpa.purchasePrice) || 0) * qty;
                      byKey[key].commission += (parseFloat(det.cpa.commission) || 0) * qty;
                    }
                    const arr = Object.values(byKey);
                    if(arr.length > 1){
                      pd.cpa.cpaSuppliers = arr;
                    }
                  }
                }
              }
              this.expeditionCount=this.formData.expeditions.length;
              this.dataGroupedByCountry= _.chain(this.formData.details).groupBy("country").map((value, key) => ({ 
                country: key,currency:value[0].currency||null,
                count: value.length,
                orders: value,
                fees:value.map(item => 
                 item.confirmation_vat+item.fulfillement_fees_vat+item.shipping_cancel_vat+
                 item.shipping_refund_vat+item.shipping_vat+(item.quality_control||0)+
                 (item.upsell_vat||0) +
                 this.$f.checkMarketplace(item.marketplaces||[],'feesPayment')
                ).reduce((prev, next) => prev + next),
                sales: value.map(item => {
                  if(item.affiliate && item.affiliate.type) return item.affiliate.commission;
                  if(item.cpa && item.cpa.supplier){
                    const orderDets = item.order && item.order.details || [];
                    const allCpa = orderDets.length > 0 && !orderDets.some(d => !d.cpa || !d.cpa.supplier);
                    let cpaComm=0;
                    if(item.cpa.cpaSuppliers && Array.isArray(item.cpa.cpaSuppliers)){ item.cpa.cpaSuppliers.forEach(cs=>{ if((cs.commissionMode||'confirmed')!=='confirmed') cpaComm+=parseFloat(cs.commission)||0; }); }
                    else { if((item.cpa.commissionMode||'confirmed')!=='confirmed') cpaComm=parseFloat(item.cpa.commission)||0; }
                    if(allCpa) return cpaComm;
                    let normalSales=0;
                    for(const d of orderDets){ if(!d.cpa||!d.cpa.supplier) normalSales+=(parseFloat(d.unitPrice)||0)*(parseInt(d.quantity)||1); }
                    return cpaComm + normalSales;
                  }
                  if(item.POD && item.POD.name) return item.POD.commission;
                  return item.order.totalPrice;
                }).reduce((prev, next) => prev + next),
                amount:value.map(item => item.amount).reduce((prev, next) => prev + next) 
              })).value();
              this.dataGroupedExpeditionsByCountry= _.chain(this.formData.expeditions).groupBy("country").map((value, key) => ({ country: key,currency:value[0].currency||null,count: value.length, expeditions: value,fees:value.map(item => item.fees_amount).reduce((prev, next) => prev + next) })).value();
              this.dataGroupedRefundsByCountry= _.chain(this.formData.refunds).groupBy("country").map((value, key) => ({ country: key,currency:value[0].currency||null,count: value.length, refunds: value,fees:value.map(item => item.fees_amount).reduce((prev, next) => prev + next) })).value();
              this.dataGroupedChargesByCountry= _.chain(this.formData.charges).groupBy("country").map((value, key) => ({ country: key,currency:value[0].currency||null,count: value.length, charges: value,fees:value.map(item => item.fees_amount).reduce((prev, next) => prev + next) })).value();
              console.log('dataGroupedByCountry-----------',this.dataGroupedByCountry)   
              console.log('expeditions r-----------',this.formData.expeditions)   
              this.getTotal(this.formData.details);
                if(this.formData.details[0] && this.formData.details[0]){
                    // if(this.formData.details[0].confirmation_vat===0)  this.headers.splice(this.headers.findIndex(item => item === this.$t('confirmation')), 1)
                    // if(this.formData.details[0].fulfillement_fees_vat===0)  this.headers.splice(this.headers.findIndex(item => item === this.$t('fulfillement')), 1)
                    // if(this.formData.details[0].quality_control===0) this.headers.splice(this.headers.findIndex(item => item === this.$t('quality_control')), 1)
                    // if(this.formData.country!='MA') this.headers.splice(this.headers.findIndex(item => item === this.$t('city')), 1)
                }
                let iP = 0;
              for (const payment of this.formData.details) {
                  let product="";

                  if(payment.order.details && payment.order.details[0] && !payment.order.details[0].name){
                       console.log('----pr not exiist----')
                         for (let i in payment.order.details) {

                            if(payment.order.details[i] && payment.order.details[i].product){
                                if(!this.dataProducts.find(o => o.id.toString() === payment.order.details[i].product.toString())){
                                  const editData = await this.$server.get("products", {id:payment.order.details[i].product,});
                                  this.dataProducts.push({id:payment.order.details[i].product.toString(),name:editData.content.name})
                                }
                                product+=this.dataProducts.find(o => o.id.toString() === payment.order.details[i].product.toString()).name
                                if(payment.order.details.length-1 != i) product+=" | "; 
                                payment.products=product;
                            }    

                         }
                   }
                   
                  iP++;     
                 if(iP === this.formData.details.length) finalExcuse=true;
              }
              if(this.formData.infoCurrency){
                  for (let i in this.formData.infoCurrency) {
                      if(this.formData.infoCurrency[i].currency == 1){
                          const resW = await this.$server.get("warehouses", { country: this.formData.infoCurrency[i].country}); 
                          console.log('resW.content._id--------',resW.content._id)
                          const dataWahrhouse = await this.$server.get("settings",{warehouse:resW.content._id});
                          console.log('dataWahrhouse--------',dataWahrhouse)
                          const currentSettingW= this.getElementInArray(dataWahrhouse.content[0].details,resW.content._id);
                          this.formData.infoCurrency[i].currency = currentSettingW.info.currency;
                      }     
                  }
              }else{
                  if(!this.formData.info || (this.formData.info && this.formData.info.currency ==1)){
                      const resW = await this.$server.get("warehouses", { country: this.formData.country}); 
                      console.log('resW.content._id--------',resW.content._id)
                      const dataWahrhouse = await this.$server.get("settings",{warehouse:resW.content._id});
                      console.log('dataWahrhouse--------',dataWahrhouse)
                      const currentSettingW= this.getElementInArray(dataWahrhouse.content[0].details,resW.content._id);
                      this.formData.info.currency=currentSettingW.info.currency;
                  }
              }
            
              if(this.formData.amountCurrency &&  this.formData.infoCurrency && this.formData.infoCurrency.length>0 && this.formData.amountCurrency.length>0){
                    this.formData.amountCurrency =this.sumObjAmountCurrency(this.formData.amountCurrency,this.formData.infoCurrency,this.formData.amountRefundsCurrency||[],this.formData.amountExpeditionsCurrency||[],this.formData.amountChargesCurrency||[]);
                    this.invoiceData.warehouses="";        
                    this.formData.country.forEach(function (war,j) {
                      this.invoiceData.warehouses += this.$f.getCountryNameByCode(this.options,war)+`${j!=this.formData.country.length-1?', ':''}`;        
                    }.bind(this));
                    this.invoiceData.sales=this.invoiceData.fees=this.invoiceData.amount="";   
                
                  this.formData.amountCurrency.forEach(function (price,j) {
                      this.invoiceData.sales += `${price.totalPrice.toFixed(2)} ${price.currency}${j!=this.formData.amountCurrency.length-1?'|':''}`;  
                      this.invoiceData.fees += `${price.fees.toFixed(2)} ${price.currency}${j!=this.formData.amountCurrency.length-1?'|':''}`;  
                      this.invoiceData.amount += `${price.amount.toFixed(2)} ${price.currency}${j!=this.formData.amountCurrency.length-1?'|':''}`;        
                  }.bind(this));

                  this.invoiceData.mad=this.formData.amountCurrency.map(item => {
                      const objC = this.formData.infoCurrency.find(o => o.currencyName === item.currency); 
                      return item.amount/objC.currency;
                  }).reduce((prev, curr) => prev + curr, 0).toFixed(2);          
              }

              if (this.formData.primes && this.formData.primes.length > 0) {
                const checkDataOffre = this.formData.primes.find((ell) => ell.id && ell.id.type === "affiliate");
                const checkDataCPA = this.formData.primes.find((ell) => ell.id && ell.id.type === "cpa");
                const checkDataMARKET = this.formData.primes.find((ell) => ell.id && ell.id.type === "marketplace");

                if (checkDataOffre && !this.idP) this.dataAFF = checkDataOffre.id.affiliates;
                if (checkDataCPA && !this.idP) this.dataAFF = (this.dataAFF || []).concat(checkDataCPA.id.affiliates || []);
                if (checkDataMARKET && !this.idP) this.dataMARKET = checkDataMARKET.id.marketplaces;
              }
              this.loading=false;  
              if(this.idP){
                setTimeout(() => (this.$store.dispatch("actionloadingemail",{loadingEmail:'final'})), 1300);
              } 
           
          }

         
        }
    }
  },
};
</script>

<style scoped>
.login-or {
  position: relative;
  color: rgb(0 0 0 / 55%);;
  margin-top: 10px;
  margin-bottom: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.hr-or {
  height: 2px;
    margin-top: 0px !important;
    margin-bottom: 0px !important;
    border: 0;
    border-top: 2px solid rgb(0 0 0 / 55%);
}
.span-or {
  display: block;
    position: absolute;
    left: 39%;
    top: -2px;
    background-color: #fff;
    width: 190px;
    text-align: center;
    font-weight: 700;
}
.invoice {
  display: flex;
}
.invoice-title {
    color: #999;
    font-size: 1.875rem;
    line-height: 2.25rem;
    margin-bottom: 0;
    font-weight: 700;
    text-transform: uppercase;
}
.invoice-des {
  text-align: right;
  margin-left: auto;
}
.invoice-logo{
    margin-left: auto;
    width: 10.5rem;
    height: auto;
    display: block;
    vertical-align: middle;
}
caption {
  background: #cdcdcd;
  font-weight: bold;
  font-size: 1.1em;
  margin-left: -1px; /* Fix FF 1px issue */
}
.w-40{
  width: 25em;
}
.empty-row{
   background: repeating-linear-gradient( 53deg , #bfc0c2 4%, #fcfcff 11px 6%, #ffffff 10px 7%, #9d9c9c 15px);
}
/* animation for vue transition tag */
dialog[open] {
  animation: appear 0.15s cubic-bezier(0, 1.8, 1, 1.8);
}
dialog::backdrop {
  background: linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(54, 54, 54, 0.5));
  backdrop-filter: blur(3px);
}
table{max-width: 100%;overflow: scroll;}
@keyframes appear {
  from {
    opacity: 0;
    transform: translateX(-3rem);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
</style>

